window.__pt = window.__pt || {};
window.__pt.ln = window.__pt.ln || {};
window.__pt.settings = window.__pt.settings || {};

/** Dates */
window.__pt.settings.formatBoxDate = "DD MMM YYYY";
window.__pt.settings.formatBoxDateMobile = "DD MMM";
window.__pt.settings.formatDate = "yyyy-MM-dd";
window.__pt.settings.formatMomentDate = "YYYY-MM-DD";
window.__pt.settings.formatDateSlash = "dd/MMM/yyyy";
window.__pt.settings.formatDateSlashBook = "dd/MMMM/yyyy";
window.__pt.ln = {
    yourSelectionIncludes: "Tu selección incluye {0}<br> {1} de las {2} <br>solicitadas en tu búsqueda.<br>Te sugerimos revisar tu selección",
    uriHotels: "/hoteles",
    and: "y",
    continue: 'Continuar',
    total: "Total",
    dateFrom: "Del",
    dateTo: "al",
    nights: "noches",
    night: "noche",
    nightm: "noche",
    nighstm: "noches",
    person: "persona",
    persons: "personas",
    pay: 'Realizar reserva',
    adult: 'adulto',
    adults: 'adultos',
    persons: 'personas',
    person: 'persona',
    child: 'menor',
    children: 'menores',
    the: 'de',
    years: 'años',
    year: 'año',
    minore: 'niño',
    minores: 'niños',
    room: 'habitación',
    rooms: 'habitaciones',
    selecteds: "seleccionadas",
    selected: "seleccionada",
    for: "para",
    fora: "por",
    free: 'Gratis',
    locale_lang: "es",
    locale: 'es-es',
    loading: 'loading..',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    capacity: 'Máximo {0} persona',
    kidsFreeTo: 'de 0 a {0} años',
    errorLogin: "Ocurrió un error inesperado.",
    errorVerification: "Ocurrió un error inesperado durante la verificación del correo electrónico.",
    errorConfigSesion: "Ocurrió un error inesperado durante la configuración de la sesión.",
    errorDeletingAccount: "Error al eliminar la cuenta: Error deleting account: ",
    noUserLoggedIn: "No hay ningún usuario conectado actualmente.",
    errorSendingPasswordResetEmail: "Error al enviar el correo de restablecimiento de contraseña.",
    errorSigningOut: "Error al cerrar sesión:",
    errorResendingVerificationEmail: "Error al reenviar el correo de verificación:",
    uniqueRoom: "Habitación única",
    recommendedRoom: "Recomendado",
    guests: "huéspedes",
    guest: "huésped",
    roomTypes: "Tipos de habitaciones",
    remainings:"Faltan",
    remaining:"Falta",
    rating: {
        "10": "Excelente",
        "9": "Sobresaliente",
        "8": "Muy Bueno",
        "7": "Bueno",
        "default": "Conveniente",
    },
    rating_reviews: {
        "1": "Terrible",
        "2": "Malo",
        "3": "Aceptable",
        "4": "Bueno",
        "5": "Excelente",
    },
    rating_reviews_range: [
        {
            "display": "Excepcional",
            "range": [10, 10]
        },
        {
            "display": "Excelente",
            "range": [9, 9.9]
        },
        {
            "display": "Muy Bueno",
            "range": [8, 8.9]
        },
        {
            "display": "Bueno",
            "range": [7, 7.9]
        },
        {
            "display": "Aceptable",
            "range": [6, 6.9]
        },
        {
            "display": "Regular",
            "range": [5, 5.9]
        },
        {
            "display": "Deficiente",
            "range": [4, 4.9]
        },
        {
            "display": "Malo",
            "range": [3, 3.9]
        },
        {
            "display": "Muy Malo",
            "range": [2, 2.9]
        },
        {
            "display": "Pésimo",
            "range": [0, 1.9]
        }
    ],
    promotions_keys: {
        "21": "Oferta entre semana",
        "16": "Hot Sale",
        "115": "Oferta Buen Fin"
    },
    hotel_lang: "Hotel",
    flight_round_pricetravel: "Vuelo redondo",
    flight_round_tiquetesbaratos: "Vuelo de ida y regreso",
    flight_one_way_pricetravel: "Vuelo sencillo",
    flight_one_way_tiquetesbaratos: "Vuelo solo de ida",
    package_lang: "Hotel + Vuelo",
    new_room: "hab.",
    new_pers: "pers.",
    all_options: "Todas las opciones",
    price_calendar_footer: "Precios aproximados en {currency} por noche para 2 adultos",
    day: "dia",
    days: "dias",
    low_prices: "Precios bajos",
    lower_prices: "Precios más bajos",
    "to": "a",
    goToImage: "Ir a la imagen {0}",
    nearby: "Cerca de",
    price_asc: 'Precio (menor a mayor)',
    price_desc: 'Precio (mayor a menor)',
    stars_desc: 'Estrellas (mayor a menor)',
    savings: 'Mayor ahorro',
    add_more_rooms: 'agrega más habitaciones'
};

window.__pt.ln.availabilityMessages = {
    "minimumstay": {
        "title1": "Habitaciones con mínimo de estancia",
        "title2": "Intenta reservar un mínimo de {{days}} noches"
    },
    "maximumstay": {
        "title1": "Habitaciones con máximo de estancia.",
        "title2": "Intenta reservar un máximo de {{days}} noches"
    },
    "none": {
        "title1": "Sin disponibilidad para estas fechas",
        "title2": "Intenta consultando otras fechas o llama sin costo"
    },
    "peoplemax": {
        "title1": "Capacidad máxima de huéspedes",
        "title2": "Intenta cambiando el número de personas o de habitaciones"
    },
    "adultsmax": {
        "title1": "Superas el límite de adultos por habitación",
        "title2": "Intenta cambiando el número de habitaciones"
    },
    "kidsmax": {
        "title1": "Superas el límite de niños por habitación",
        "title2": "Intenta cambiando el número de personas o de habitaciones"
    },
    "kidszero": {
        "title1": "Superas el límite de niños por habitación",
        "title2": "Intenta seleccionando solo adultos"
    },
    "defaults": { "minimumstay": 5, "maximumstay": 30 },
    "needhelp": "¿Necesitas ayuda? Comunicate con nuestros asesores al "
};

window.__pt.ln.mealplans = {
    "A": "Desayuno americano",
    "AA": "Navidad y Fin de Año Imperial",
    "AB": "Escapada Romántica",
    "AC": "Escapada Romántica y Spa",
    "AD": "Comida y cena con bebidas incluidas",
    "AE": "Desayuno (solo adultos)",
    "AF": "Desayuno Gourmet Americano",
    "AG": "Desayuno para 2",
    "AH": "Desayuno Continental para 2",
    "AI": "Desayuno y Almuerzo",
    "AJ": "Desayuno, almuerzo, cena, con liquidos",
    "AK": "Semi todo incluido",
    "KA": "Semi todo incluido",
    "AL": "3 comidas + 2 snacks",
    "AM": "Dining Plan",
    "AN": "Quick Service",
    "AO": "Desayuno, comida o cena, sin líquidos",
    "AP": "Desayuno, merienda y cena",
    "AQ": "Desayuno, almuerzo o cena",
    "AR": "No Reembolsable",
    "AS": "Bebidas Incluidas",
    "AT": "Desayuno, comida y cena solo adultos",
    "AU": "Desayuno continental solo adultos",
    "AV": "Desayuno",
    "AW": "Alimentos, Bebidas y Tours Incluidos",
    "AX": "Desayuno para 1 adulto",
    "AY": "Cena",
    "AZ": "Todo Incluido",
    "B": "Desayuno bufet",
    "BA": "Premium",
    "C": "Comida",
    "E": "Solo alojamiento",
    "EF": "Solo alojamiento",
    "F": "Desayuno y cena incluidos",
    "G": "Desayuno, comida y cena",
    "H": "Desayuno, comida o cena",
    "I": "Todo incluido",
    "J": "Desayuno bufet continental",
    "K": "Alimentos y bebidas incluidas",
    "L": "Desayuno",
    "M": "Desayuno y cena con bebidas incluidas",
    "N": "Desayuno sin líquidos",
    "O": "Barra libre",
    "P": "Desayuno y cena, sin liquidos",
    "Q": "Desayuno, almuerzo y cena, sin liquidos",
    "R": "Desayuno bufet sin bebidas",
    "S": "Desayuno y comida o cena, sin líquidos",
    "T": "Comida sin líquidos",
    "U": "2 comidas quick service + 1 snack",
    "V": "2 comidas + 1 snack",
    "W": "3 alimentos sin bebidas",
    "X": "Cena sin líquidos",
    "Y": "Desayuno continental sin líquidos",
    "Z": "Desayuno continental",
    "AR": "Solo alojamiento",
    "BA": "Alimentos y bebidas Premium",
    "BB": "Crédito del resort incluido",
    "BZ": "Desayuno bufet",
    "EL": "Solo alojamiento con promoción",
    "GR": "Desayuno, comida y cena",
    "HR": "Desayuno, comida o cena",
    "KR": "Alimentos y bebidas incluidas",
    "MR": "Desayuno y cena con bebidas",
    "PR": "Desayuno y Cena",
    "XB": "Golf AM - Desayuno bufet",
    "XE": "Golf AM - Solo alojamiento",
    "ZA": "Desayuno americano",
    "ZR": "Desayuno continental",
    "KITCHEN": "Con Cocina"
};

window.__pt.ln.freecancellation = {
    "notallowed": "No reembolsable",
    "allowed": "Cancelación gratis",
};

window.__pt.ln.promotion = {
    "40%dedescuento+2niñosgratis": "40% de descuento + 2 niños gratis",
    "ventaespecial": "Venta especial",
    "ofertadeverano": "Oferta de verano",
    "promociónelbuenfin": "Promoción de Buen Fin",
    "blackfriday": "Black Friday",
    "20-30": "20% de descuento",
    "30-40": "30% de descuento",
    "40-50": "40% de descuento",
    "50-100": "Desde 50% de descuento",
    "hotsale": "Hot Sale",
    "festivaldeviajes": "Travel sale",
    "travelsale": "Travel Sale",
    "megaofertas": "Mega Ofertas"
};
window.__pt.ln.campaigns = {
    "hotsale": "Hot Sale",
    "ofertahot": "Oferta Hot",
    "buenfin": "Buen Fin",
    "blackdays": "Black Days",
    "blackfriday": "Black Friday",
    "ofertaimperdible": "Oferta Imperdible",
    "outlet": "Outlet",
    "megaoferta": "Mega Oferta"
};
window.__pt.ln.paymentmethods = {
    "2": "Paga en el alojamiento"
}
window.__pt.ln.stars = {
    "5": "5 estrellas",
    "4": "4 estrellas",
    "3": "3 estrellas",
    "2": "2 estrellas",
    "1": "1 estrella"
};

window.__pt.ln.reviews = {
    "dwonderful": "Excelente: 9 o más",
    "bverygood": "Muy Bueno: 8 o más",
    "agood": "Bueno: 7 o más"
};
window.__pt.ln.filterslang = {
    "zones": "zonas",
    "amenities": "amenidades",
    "room-view": "vista-de-la-habitacion",
    "interest": "interes"
};
window.angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "a.m.",
                "p.m."
            ],
            "DAY": [
                "domingo",
                "lunes",
                "martes",
                "mi\u00e9rcoles",
                "jueves",
                "viernes",
                "s\u00e1bado"
            ],
            "ERANAMES": [
                "antes de Cristo",
                "despu\u00e9s de Cristo"
            ],
            "ERAS": [
                "a. C.",
                "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre"
            ],
            "SHORTDAY": [
                "dom.",
                "lun.",
                "mar.",
                "mi\u00e9.",
                "jue.",
                "vie.",
                "s\u00e1b."
            ],
            "SHORTMONTH": [
                "Ene.",
                "Feb.",
                "Mar.",
                "Abr.",
                "May.",
                "Jun.",
                "Jul.",
                "Ago.",
                "Sep.",
                "Oct.",
                "Nov.",
                "Dic."
            ],
            "STANDALONEMONTH": [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "d MMM y HH:mm:ss",
            "mediumDate": "d MMM y",
            "mediumTime": "HH:mm:ss",
            "short": "d/M/yy HH:mm",
            "shortDate": "d/M/yy",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "-\u00a4",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
            ]
        },
        "id": "es-419",
        "localeID": "es_419",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}]);


window.__pt.settings.loginErrors = {
    "auth/account-exists-with-different-credential": "El correo electrónico ya está en uso con diferentes credenciales",
    "auth/email-already-in-use": "La dirección de correo electrónico ya está en uso por otra cuenta",
    "auth/invalid-email": "La dirección de correo electrónico tiene un formato incorrecto",
    "auth/operation-not-allowed": "La operación no está permitida",
    "auth/weak-password": "Contraseña muy débil",
    "auth/auth-domain-config-required": "Proveedor no autorizado",
    "auth/cancelled-popup-request": "Se ha cancelado el inicio de sesión",
    "auth/operation-not-supported-in-this-environment": "El inicio de sesión con contraseña está deshabilitado para este proyecto",
    "auth/user-disabled": "La cuenta de usuario ha sido deshabilitada por un administrador",
    "auth/user-not-found": "No hay ningún registro de usuario correspondiente a este correo",
    "auth/wrong-password": "La contraseña es inválida o el usuario no tiene contraseña",
    "auth/too-many-requests": "Hemos bloqueado todas las solicitudes por actividad inusual. Inténtalo más tarde",
    "auth/invalid-verification-code": "Código de verificación inválido",
    "auth/invalid-verification-id": "ID de verificación inválido",
    "auth/missing-verification-code": "Falta el código de verificación",
    "auth/missing-verification-id": "Falta el ID de verificación",
    "auth/credential-already-in-use": "La credencial ya está en uso",
    "auth/expired-action-code": "El enlace de {0} ha expirado",
    "auth/invalid-action-code": "El enlace de {0} es inválido",
    "auth/invalid-credential": "Credencial inválida",
    "auth/invalid-phone-number": "Formato de teléfono inválido",
    "auth/missing-phone-number": "Falta el número de teléfono",
    "auth/quota-exceeded": "Límite de cuota excedido",
    "auth/timeout": "Tiempo de espera agotado",
    "auth/provider-already-linked": "El proveedor ya está vinculado",
    "auth/requires-recent-login": "Requiere autenticación reciente",
    "auth/unauthorized-domain": "Dominio no autorizado",
    "auth/invalid-api-key": "API key inválida",
    "auth/network-request-failed": "Error de red",
    "action_type/reset": "restablecimiento de contraseña",
    "action_type/verify": "verificación de correo"
}

window.__pt.ln.overriteTitles = {
    "Amenidades": "Instalaciones y servicios"
}

window.__pt.ln.paths = {
    "listPath": "hoteles-en-",
};


window.__pt.ln.numberWords = {
    units: [
        'cero','uno','dos','tres','cuatro','cinco','seis','siete','ocho','nueve','diez',
        'once','doce','trece','catorce','quince','dieciséis','diecisiete','dieciocho','diecinueve','veinte',
        'veintiuno','veintidós','veintitrés','veinticuatro','veinticinco','veintiséis','veintisiete','veintiocho','veintinueve'
    ],
    tens: {
        20: 'veinte', 30: 'treinta', 40: 'cuarenta', 50: 'cincuenta',
        60: 'sesenta', 70: 'setenta', 80: 'ochenta', 90: 'noventa'
    },
    hundreds: {
        100: 'cien', 200: 'doscientos', 300: 'trescientos', 400: 'cuatrocientos',
        500: 'quinientos', 600: 'seiscientos', 700: 'setecientos', 800: 'ochocientos', 900: 'novecientos'
    },
    magnitude: {
        thousand: 'mil',
        millionSingular: 'millón',
        millionPlural: 'millones'
    },
    joiner: ' y '
};

window.__pt.ln.currencyWords = {
    MXN: 'pesos mexicanos',
    USD: 'dólares estadounidenses',
    COP: 'pesos colombianos',
    CAD: 'dólares canadienses',
    EUR: 'euros',
    ARS: 'pesos argentinos',
    BRL: 'reales brasileños',
    CLP: 'pesos chilenos',
    CNY: 'yuanes chinos',
    GBP: 'libras esterlinas',
    JPY: 'yenes japoneses',
    PEN: 'soles peruanos',
    UYU: 'pesos uruguayos'
};


window.__pt.ln.mealPlanNormalization = {
    "tiquetesbaratos": [
        { from: 'comida', to: 'almuerzo' },
        { from: 'Comida', to: 'Almuerzo' },
    ],
    // "pricetravel": [
    //     { from: 'almuerzo', to: 'comida' }
    // ]
}

window.__pt.ln.bedspreference = {
    "2": "Utensilios de cocina",
    "3": "Vajilla y cubettería",
    "4": "Plancha y tabla de planchar",
    "5": "Tendedero",
    "6": "Secador de pelo",
    "7": "Ropa de cama y toallas",
    "8": "Artículos de aseo",
    "9": "Calefacción central",
    "11": "Lavadora",
    "13": "Lavavajillas",
    "17": "Hervidor de agua",
    "19": "TV por cable",
    "21": "Despertador",
    "22": "Equipo de música",
    "23": "DVD",
    "24": "Reproductor de CD",
    "25": "Reproductor de video (VHS)",
    "27": "También hay un segundo baño separado",
    "29": "Bidé",
    "32": "Armario",
    "33": "Armario de tocador",
    "35": "Baño jacuzzi con ducha",
    "36": "Lavabo con espejo",
    "37": "Inodoro",
    "46": "Plato de ducha",
    "50": "Cuarto de ducha",
    "52": "Bañera con ducha",
    "53": "WC",
    "55": "Cuna para bebé",
    "56": "Opcional: trona para bebé",
    "58": "Radiadores",
    "61": "Cama doble / matrimonio",
    "63": "Opcional: cuna y trona para bebé",
    "66": "Armarios empotrados",
    "69": "Roperos",
    "70": "Mesita de noche",
    "71": "Mesitas de noche",
    "72": "Lámparas de lectura",
    "73": "Escritorio",
    "74": "Televisor",
    "78": "Cómoda",
    "79": "Baño/WC",
    "81": "Baño",
    "82": "Baños",
    "87": "Dormitorios",
    "89": "Balcón",
    "91": "Pequeña terraza",
    "92": "Invernadero con mesa y sillas",
    "93": "Terrazas",
    "94": "Cocina en salón / comedor",
    "96": "Balcón pequeño",
    "97": "Recibidor",
    "98": "Pasillo",
    "99": "Salón",
    "100": "Terraza",
    "101": "Cocina",
    "102": "Cocina moderna",
    "106": "Estanterías para libros",
    "110": "Fogones con horno",
    "114": "Fogones",
    "115": "Horno",
    "118": "Estilo moderno",
    "119": "Cocina económica",
    "123": "Hervidor eléctrico",
    "124": "Microondas",
    "125": "Tostadora",
    "127": "Estilo tradicional",
    "128": "Platos",
    "129": "Ollas y sartenes",
    "130": "Nevera / congelador",
    "131": "Nevera",
    "133": "Mini tabla de planchar",
    "134": "Lavadora secadora",
    "135": "Cocina totalmente equipada",
    "137": "Lavadora secadora de ropa",
    "140": "Cafetera",
    "142": "Escurreplatos",
    "143": "Aspiradora",
    "144": "Tetera",
    "146": "Fogones de gas/eléctricos",
    "147": "Horno eléctrico",
    "150": "Barra de desayuno con taburetes",
    "151": "Mesa y sillas de cocina",
    "152": "Congelador",
    "157": "Kitchenette",
    "161": "Sillones",
    "163": "Mesa de centro",
    "166": "TV (solo canales locales)",
    "167": "TV vía satélite",
    "174": "Conexión a internet",
    "180": "Aire acondicionado",
    "181": "Aire acondicionado / calefacción",
    "182": "Sofá",
    "186": "Unidad de aire acondicionado portátil",
    "187": "Calefacción",
    "188": "Lámpara",
    "189": "Mesa y sillas",
    "192": "Sofá de cuero",
    "193": "Sillón con reposapiés",
    "197": "Estantes",
    "198": "Radio",
    "199": "Ordenador con acceso gratuito a internet (ASDL)",
    "200": "Sofá cama doble",
    "201": "Armario",
    "203": "Sofá doble",
    "204": "Salón confortable en el lugar",
    "205": "Mostrador de ayuda",
    "208": "Tronas",
    "209": "Cama extra",
    "210": "Colchón",
    "215": "Servicio de recogida en el aeropuerto",
    "225": "Servicio de limpieza",
    "227": "Piscina",
    "231": "Limpieza semanal gratuita",
    "232": "Lavandería y tintorería",
    "233": "Tintorería",
    "234": "Lavandería",
    "235": "Desayuno",
    "237": "Sofá cama",
    "239": "Ducha",
    "245": "Lavabo",
    "248": "Espacio de almacenamiento",
    "249": "Salón",
    "250": "Mesa de comedor",
    "252": "Bañera",
    "253": "Jacuzzi",
    "257": "Dormitorio",
    "258": "Estufa / Cocina económica",
    "261": "Ventilador",
    "277": "Muebles antiguos",
    "281": "Posible acceso para sillas de ruedas",
    "294": "Gimnasio en el edificio para uso de los huéspedes",
    "295": "Aparcamiento en la calle",
    "296": "Aparcamiento subterráneo",
    "298": "Conserje en el edificio",
    "302": "Aparcamiento vigilado",
    "308": "Teléfono (solo llamadas entrantes)",
    "309": "Teléfono (llamadas entrantes y salientes)",
    "311": "Tocador",
    "312": "Máquina de fax",
    "314": "Internet (con ordenador incluido)",
    "315": "Bañera",
    "320": "Entrada separada",
    "321": "Baño separado",
    "322": "Puerta a la terraza",
    "323": "Cama individual",
    "324": "Cama tamaño king",
    "325": "Reproductor de DVD",
    "326": "Selección de CD",
    "327": "Selección de DVD",
    "328": "Suelo radiante",
    "330": "Mapas de la ciudad",
    "331": "Nevera totalmente abastecida",
    "332": "Folletos informativos",
    "334": "Comida y bebida GRATIS",
    "336": "Frutas GRATIS",
    "337": "Ramos de flores GRATIS",
    "338": "Leña GRATIS para la chimenea",
    "339": "Acceso a internet GRATIS",
    "341": "Sábanas finas de algodón egipcio",
    "342": "Selección de comida y bebida",
    "344": "Albornoz",
    "345": "Panel LCD",
    "346": "Jardín",
    "347": "Amplia selección de comida de lujo, bebidas, vinos, cafés y tés",
    "348": "Nevera totalmente abastecida con todo tipo de comida fresca y bebidas",
    "349": "Chimenea de leña",
    "351": "Toallas de baño grandes de rizo",
    "352": "Artículos de aseo \"Molton Brown\"",
    "353": "Plantas de orquídeas",
    "354": "Línea telefónica internacional GRATIS",
    "355": "En estancias semanales: servicio de limpieza que incluye lavandería / planchado personal",
    "359": "Piano",
    "360": "Secadora",
    "361": "Campana extractora",
    "362": "Cocina, salón y jardín compartidos con otros huéspedes",
    "363": "Sillón",
    "364": "Chimenea",
    "365": "Sauna",
    "368": "Internet inalámbrico gratuito",
    "371": "Cine en casa",
    "372": "Salón / Dormitorio",
    "373": "Cocina común",
    "374": "Alquiler de teléfonos móviles",
    "375": "Servicios de fax y fotocopias",
    "376": "Cafetera",
    "379": "TV por cable digital",
    "380": "Té y café de cortesía",
    "382": "Sillas auxiliares",
    "384": "Literas (individual arriba, doble abajo)",
    "385": "Cunas, tronas, colchón (bajo petición)",
    "388": "Desván / Loft",
    "389": "TV de plasma de pantalla plana",
    "390": "Máquina de espresso",
    "391": "Bañera de hidromasaje",
    "395": "Toallas",
    "396": "Dormitorio en nicho / alcoba",
    "397": "Mesita auxiliar",
    "404": "Club de salud",
    "408": "Parrilla / Barbacoa",
    "409": "Baño privado en suite",
    "412": "Vestidor",
    "413": "Máquina de hielo",
    "414": "Lavabo doble",
    "415": "Piscina de spa",
    "417": "Llamadas de larga distancia gratuitas",
    "418": "Sistema de videojuegos",
    "419": "Sistema de videojuegos con juegos",
    "420": "Uso gratuito de radios bidireccionales",
    "421": "Sala de juegos",
    "422": "Artículos de aseo iniciales",
    "426": "Teléfono (llamadas entrantes y locales salientes)",
    "428": "Sillón que se convierte en cama individual",
    "429": "Alquiler de ordenadores",
    "432": "Sillón cama",
    "433": "Internet inalámbrico de alta velocidad gratuito",
    "434": "Inodoro/bidé",
    "435": "Estufa de gas",
    "436": "Batidora / Licuadora",
    "437": "Placas calientes",
    "438": "Acceso a internet de alta velocidad",
    "439": "Comedor",
    "440": "Par de camas individuales",
    "444": "Litera",
    "445": "TV de gran pantalla",
    "446": "Jabón / Champú / Acondicionador de cortesía",
    "447": "Toallero calefactado",
    "448": "Limpieza semanal gratuita",
    "449": "Río",
    "450": "Calle",
    "451": "Patio interior",
    "452": "Plaza",
    "453": "Habitación anexa",
    "454": "Suelo de mármol",
    "455": "2 camas individuales en el salón",
    "456": "Sillas",
    "457": "Invernadero",
    "458": "Ducha de hidromasaje",
    "459": "Suelo de parqué",
    "460": "Sofá seccional / modular",
    "461": "Centro de negocios",
    "462": "Electrodomésticos de última generación",
    "463": "Encimeras de granito",
    "464": "Armarios a medida",
    "465": "Pista de tenis",
    "466": "Guardería",
    "467": "Gimnasio de la residencia",
    "468": "TV de pantalla plana LCD",
    "472": "Servicio de compras personal",
    "473": "Cuarto de estar / Guarida",
    "476": "Horizonte de la ciudad",
    "478": "Centro de la ciudad",
    "479": "Campo de golf",
    "480": "TV de pantalla panorámica",
    "481": "Suelo de madera",
    "482": "Maquinilla de afeitar eléctrica",
    "483": "Ventanas de madera",
    "484": "Libros guía",
    "485": "Cama tamaño queen",
    "490": "Ventiladores bajo petición",
    "491": "Plancha/Tabla de planchar bajo petición",
    "497": "Instalaciones para guardar equipaje",
    "499": "Percha",
    "500": "Estantería",
    "501": "Cama de día / Diván",
    "503": "Espejo",
    "504": "Aparcamiento privado",
    "505": "Guardarropa / Vestíbulo",
    "506": "Armarios",
    "507": "Mesa",
    "508": "Silla",
    "509": "Lámpara de lectura",
    "510": "Lago",
    "511": "Mar",
    "512": "Océano",
    "513": "Canal",
    "514": "Entresuelo",
    "515": "Cama abatible",
    "516": "Ducha en suite",
    "517": "Dormitorio/Salón con rincón de cocina",
    "589": "Ropa de cama",
    "590": "Plancha",
    "591": "Tabla de planchar",
    "592": "Teléfono",
    "593": "Ordenador",
    "594": "Vista al canal",
    "595": "Se admiten mascotas",
    "596": "Cuna gratuita en el apartamento",
    "597": "Cuna gratuita bajo petición",
    "598": "Conserjería",
    "599": "Lavadora secadora",
    "600": "Secadora",
    "601": "Caja fuerte",
    "602": "Almacén de esquí",
    "603": "Vista a la montaña",
    "604": "Vista al mar",
    "605": "Sala de fitness",
    "606": "Spa",
    "607": "Baño de vapor",
    "608": "Servicio de habitaciones",
    "609": "Vista a la pista de esquí",
    "611": "Bañera de hidromasaje (privada)",
    "612": "Bañera de hidromasaje (común)",
    "613": "Lavandería (privada)",
    "614": "Lavandería (común)",
    "615": "Minibar",
    "616": "Portero",
    "617": "Sala de desayunos",
    "618": "Sala de reuniones",
    "619": "Restaurante",
    "620": "Bar",
    "621": "Salón de belleza",
    "622": "Zona infantil",
    "623": "Acceso directo a pistas de esquí",
    "624": "Cama supletoria extraíble",
    "625": "Jardín (privado)",
    "626": "Jardín (común)",
    "627": "Recepción",
    "628": "Servicio de lavandería",
    "629": "Habitaciones contiguas",
    "630": "Adaptadores de enchufe",
    "631": "Mostrador de aerolínea",
    "632": "Plan de comidas - Americano",
    "633": "Cajero automático",
    "634": "Equipo audiovisual",
    "635": "Servicios de canguro / infantil",
    "636": "Barbería",
    "637": "En la bahía",
    "638": "Vista a la bahía",
    "639": "Plan de comidas - Alojamiento y desayuno",
    "640": "Dispositivo de escucha para bebés",
    "641": "Vista a la playa",
    "642": "Playa",
    "643": "Peluquería/Barbería",
    "644": "Botones / Maleteros",
    "645": "Alquiler de bicicletas",
    "646": "Pizarra",
    "647": "Billar / Mesas de pool",
    "648": "Paseos en bote",
    "649": "Boutiques",
    "650": "Bolos",
    "651": "Plan de comidas - Bermudas",
    "652": "Ascensor con braille",
    "653": "Bufé de desayuno",
    "654": "Teléfono en el baño",
    "655": "Cama con dosel / de estilo colonial",
    "656": "Mostrador de alquiler de coches",
    "657": "Casino",
    "658": "Habitación estilo castillo",
    "659": "Plan de comidas - Caribeño",
    "660": "Reproductor de CD",
    "661": "Ventilador de techo",
    "662": "Vista a la ciudad",
    "663": "Instalaciones para conferencias",
    "664": "Suite para conferencias",
    "665": "Desayuno continental",
    "666": "Cafetería",
    "667": "Cafetera en la habitación",
    "668": "Ordenador en la habitación",
    "669": "Mostrador de conserjería",
    "670": "Habitaciones comunicadas",
    "671": "Plan de comidas - Continental",
    "672": "Servicio de copias",
    "673": "Teléfono inalámbrico",
    "674": "Cunas disponibles",
    "675": "Coche de cortesía",
    "676": "Centro de la ciudad",
    "677": "Cambio de divisas",
    "678": "Puerto de datos disponible",
    "679": "Recepción 24 horas",
    "680": "Guía de restaurantes",
    "681": "Cena",
    "682": "Habitaciones/instalaciones para discapacitados",
    "683": "Discoteca",
    "684": "Médico a domicilio",
    "685": "Farmacia",
    "686": "Campo de prácticas de golf",
    "687": "Escritorio con lámpara",
    "688": "Cerraduras electrónicas",
    "689": "Ascensor",
    "690": "Servicio de correo electrónico",
    "691": "Entretenimiento en vivo",
    "692": "Plan de comidas - Europeo",
    "693": "Check-in exprés",
    "694": "Escritorio ejecutivo",
    "695": "Checkout exprés",
    "696": "Planta ejecutiva",
    "697": "Plan de comidas - Pensión completa",
    "698": "Desayuno inglés completo",
    "699": "Habitaciones para ejecutivas",
    "700": "Pesca",
    "701": "Floristería",
    "702": "Aparcamiento gratuito",
    "703": "Llamadas locales gratuitas",
    "704": "Transporte gratuito",
    "705": "Vista al jardín",
    "706": "Tienda de regalos",
    "707": "Alquiler de juegos",
    "708": "Golf",
    "709": "Vista al campo de golf",
    "710": "Paseos a caballo",
    "711": "Pista para correr",
    "712": "Residencia canina",
    "713": "Actividades para niños",
    "714": "Vista al lago",
    "715": "Lavandería autoservicio para huéspedes",
    "716": "Almuerzo",
    "717": "Plan de comidas - Media pensión",
    "718": "Masaje",
    "719": "Minigolf",
    "720": "Películas en la habitación",
    "721": "Instalaciones para reuniones",
    "722": "Suite de reuniones",
    "723": "Personal multilingüe",
    "724": "Guardería infantil",
    "725": "Habitaciones/instalaciones para no fumadores",
    "726": "Club nocturno",
    "727": "Periódico gratuito",
    "728": "Quiosco de prensa",
    "729": "Vista al océano",
    "730": "Proyector de transparencias",
    "731": "Parasailing",
    "732": "Vista al parque",
    "733": "No se admiten mascotas",
    "734": "Servicio telefónico",
    "735": "Zona de pícnic / Mesas",
    "736": "Parque infantil",
    "737": "Piscina climatizada",
    "738": "Piscina cubierta",
    "739": "Piscina infantil",
    "740": "Piscina al aire libre",
    "741": "Snackbar junto a la piscina",
    "742": "Proyector",
    "743": "Squash",
    "744": "Vista al río",
    "745": "Acceso con rampa a los edificios",
    "746": "Servicio de habitaciones 24 horas",
    "747": "Caja de seguridad",
    "748": "Navegación a vela",
    "749": "Buceo",
    "750": "Servicio de secretaría",
    "751": "Seguridad 24 horas",
    "752": "Centro comercial",
    "753": "Transporte gratuito al aeropuerto",
    "754": "Tiro al plato",
    "755": "Esquí",
    "756": "Esquí de fondo",
    "757": "Snorkel",
    "758": "Snowboard",
    "759": "Centro de fitness o spa",
    "760": "Baño de vapor",
    "761": "Télex",
    "762": "Tenis cubierto",
    "763": "Tenis",
    "764": "Tenis al aire libre",
    "765": "Mostrador de información turística",
    "766": "Servicio de traducción",
    "767": "Servicios de lavandería",
    "768": "Máquinas expendedoras",
    "769": "Habitaciones/Servicios VIP",
    "770": "Voleibol",
    "771": "Servicio de despertador",
    "772": "Servicios de boda",
    "773": "Windsurf",
    "774": "Esquí acuático",
    "775": "Barras de apoyo en el baño",
    "776": "Habitaciones climatizadas",
    "777": "Módem en la habitación",
    "778": "Cama plegable tipo Murphy",
    "779": "Camas supletorias",
    "780": "Albomoz",
    "781": "Detectores de humo",
    "782": "Solárium",
    "783": "Rociadores en las habitaciones",
    "784": "Mostrador de teatro",
    "785": "Control de temperatura",
    "786": "Prensa de pantalones",
    "788": "Base para iPod",
    "789": "Calefacción",
    "790": "Equipo de alta fidelidad",
    "791": "Tienda libre de impuestos",
    "792": "Internet inalámbrico",
    "793": "Aparcamiento",
    "794": "Aparcamiento al aire libre",
    "795": "Servicio de aparcacoches",
    "796": "Esterillas de rezo",
    "797": "Pistas de ráquetbol",
    "798": "Nevera",
    "799": "Se permite fumar",
    "800": "Chef a disposición",
    "801": "Vista a la marina",
    "802": "Se permite fumar",
    "803": "Aparcamiento gratuito en la calle",
    "804": "Aparcamiento de pago en la calle",
    "805": "Aparcamiento gratuito con garaje",
    "806": "Aparcamiento de pago con garaje",
    "807": "Internet por cable gratuito",
    "808": "Internet por cable de pago",
    "809": "Internet inalámbrico de pago",
    "810": "Cuna de pago bajo petición",
    "811": "Petanque",
    "812": "Consultar sobre fumadores",
    "813": "Consultar sobre mascotas",
    "814": "Consultar sobre accesibilidad",
    "815": "Piscina comunitaria",
    "816": "Piscina privada",
    "817": "Mesa de ping-pong",
    "818": "Reserva de desayuno posible",
    "819": "Limpieza de la casa opcional",
    "820": "Deportes - natación",
    "821": "Hospital local",
    "822": "Tiendas de comestibles locales",
    "823": "Frente al agua",
    "824": "Cerca del océano",
    "825": "Cocina compartida",
    "826": "Piscina compartida",
    "827": "Garaje",
    "828": "Apto para familias/niños",
    "829": "Espacio de trabajo con portátil",
    "830": "Exprimidor / Licuadora de jugos",
    "831": "Cámara de seguridad en la entrada",
    "832": "Reproductor de MP3",
    "833": "Cuna para bebé",
    "834": "Gimnasio",
    "835": "Pádel",
    "836": "Acceso en taxi",
    "837": "Acceso a la azotea",
    "838": "Trona para bebé",
    "839": "Cuna para bebé de pago",
    "840": "Trona bajo petición",
    "841": "Trona bajo petición",
    "842": "Mascotas de pago",
    "843": "Mascotas aceptadas bajo petición",
    "844": "Cochecito de paseo",
    "845": "Cubettería para bebé",
    "846": "Conexión a internet bajo petición",
    "847": "TV por cable bajo petición",
    "848": "Lavandería/tintorería bajo petición",
    "849": "Llamadas internacionales gratuitas",
    "850": "Chimenea",
    "851": "TV 3D",
    "852": "Smart TV",
    "853": "Coche gratuito",
    "854": "Bicicleta gratuita",
    "855": "Se acepta pago con tarjeta de crédito",
    "856": "No se permiten fiestas",
    "857": "No se admiten niños menores de 4 años",
    "858": "No se admiten niños menores de 12 años",
    "859": "No se admiten menores de 25 años",
    "860": "No se admiten menores de 30 años",
    "861": "No se admiten menores de 35 años",
    "862": "No se admiten menores de 18 años",
    "863": "No se aceptan reservas de más de 30 días",
    "864": "No se admiten grupos de menores de 18 años",
    "865": "No se admiten grupos de menores de 25 años",
    "866": "No se admiten grupos de menores de 30 años",
    "867": "No se admiten grupos de menores de 35 años",
    "868": "Solo familias",
    "869": "No se admiten menores de 40 años",
    "870": "No se admiten niños menores de 6 años",
    "871": "No se admiten grupos de menores de 50 años",
    "872": "No se admiten grupos del mismo sexo menores de 30 años",
    "873": "No se admiten grupos de menores de 45 años",
    "874": "No se admiten grupos del mismo sexo menores de 35 años",
    "875": "Llegadas en domingo",
    "876": "Solo familias o parejas",
    "877": "Trona para bebé de pago",
    "878": "Trona para bebé de pago",
    "879": "Adaptador USB WiFi",
    "880": "Agua embotellada",
    "881": "Ventilación central controlada",
    "882": "Adaptadores eléctricos disponibles",
    "883": "Habitaciones hipoalergénicas",
    "884": "TV con navegador de internet",
    "885": "Convertidores de corriente",
    "886": "Kit de costura",
    "887": "Impresora",
    "888": "Zapatillas",
    "889": "Sistema de sonido",
    "890": "Ventanas insonorizadas",
    "891": "Báscula",
    "892": "Selección de habitación a la llegada",
    "893": "Ventana",
    "894": "Veranda",
    "895": "Patio",
    "896": "Aire acondicionado en áreas comunes",
    "897": "Centro de deportes acuáticos",
    "898": "Servicio de mensajería",
    "899": "Guardería",
    "900": "Servicio de limpieza",
    "901": "Actividades recreativas",
    "902": "Buceo",
    "903": "Peluquería",
    "904": "Tiendas del hotel",
    "905": "Excursiones entre islas",
    "906": "Moto acuática",
    "907": "Niños comen gratis",
    "908": "Salida tardía disponible",
    "909": "Servicio de limusina / coche de ciudad disponible",
    "910": "Guardia de seguridad",
    "911": "Limpieza de calzado",
    "912": "Máquina de limpieza de calzado",
    "913": "Servicio de transporte",
    "914": "Apto para niños",
    "915": "Servicio de venta de entradas",
    "916": "Servicio de preparación de cama",
    "917": "Paraguas / Sombrilla",
    "918": "Amenidades de bienvenida",
    "919": "Vista al campo o rural",
    "920": "Vista interior",
    "921": "Vista panorámica",
    "922": "Vista a la piscina",
    "923": "Vista al pueblo",
    "924": "Vista al valle",
    "925": "Vista al pueblo/ciudad",
    "926": "Vista poco común",
    "927": "Vista al lago escocés",
    "928": "Piscina exterior climatizada",
    "929": "No se admiten bebés",
    "930": "Apto para familias",
    "931": "Coche necesario",
    "932": "Coche recomendado",
    "933": "Coche no necesario",
    "934": "Romántico",
    "935": "Lujo",
    "936": "Económico",
    "937": "Vista al agua",
    "938": "Tumbona de playa",
    "939": "Cama francesa",
    "940": "Papel higiénico",
    "941": "Jabón",
    "942": "No se admiten niños",
    "943": "Detector de monóxido de carbono",
    "944": "Piscina privada climatizada",
    "945": "Fútbol de mesa",
    "946": "Diana",
    "947": "Mesa de hockey de aire",
    "948": "Canasta de baloncesto",
    "949": "Valla de seguridad en la piscina",
    "950": "Calefactor para patio",
    "951": "Tumbonas",
    "952": "Iluminación exterior",
    "953": "Apto para personas mayores",
    "954": "Tranquilo",
    "955": "Extintor de incendios",
    "956": "Ducha de fácil acceso (sin barreras)",
    "957": "Cama triple litera",
    "958": "Minisúper en el lugar",
    "959": "Solo adultos",
    "960": "Cambio de toallas bajo petición",
    "961": "Mejora de habitación disponible sujeta a disponibilidad",
    "962": "Mejora de habitación garantizada",
    "963": "Mejora de habitación gratuita disponible",
    "964": "Crédito en el resort incluido",
    "965": "Regalo de bienvenida a la llegada",
    "966": "Productos de limpieza ecológicos",
    "967": "Reciclaje de aguas grises",
    "968": "Energía renovable - geotérmica",
    "969": "Energía renovable - solar",
    "970": "Energía renovable - eólica",
    "971": "Artículos esenciales (toallas, almohadas, ropa de cama, jabón, papel higiénico)",
    "972": "Perchas",
    "973": "Agua caliente",
    "974": "Lavadora",
    "976": "Libre de alérgenos",
    "977": "Toallas de playa",
    "978": "Productos de limpieza",
    "979": "Tapones para los oídos",
    "980": "Taquillas",
    "981": "Mosquitera",
    "984": "Cortina privada",
    "985": "Control de clima en la habitación",
    "986": "Guía de restaurantes",
    "987": "Sistema de calefacción / refrigeración controlado por el usuario",
    "988": "Armario separado",
    "989": "Sombrillas de playa",
    "990": "Cubos de basura",
    "991": "Estación de carga para vehículos eléctricos",
    "992": "Servicio de planchado",
    "993": "Cesta para mascotas",
    "994": "Recipientes para mascotas",
    "995": "Sin plásticos de un solo uso",
    "996": "Sin artículos de aseo de un solo uso",
    "997": "Elegibilidad para puntos de fidelidad del hotel",
    "998": "Frente a la playa",
    "999": "Jardín o patio trasero",
    "1000": "Casa de una sola planta",
    "1002": "Zona designada para fumadores",
    "1003": "Independiente / Aislado",
    "1004": "Zona de estar 'engawa'",
    "1005": "Hoguera / Foso de fuego",
    "1006": "Balcón amueblado",
    "1007": "Lanai amueblado",
    "1008": "Patio amueblado",
    "1009": "Jardín japonés",
    "1010": "Pared de plantas vivas",
    "1011": "Huerto de verduras",
    "1012": "Vista al golfo",
    "1013": "Vista al puerto",
    "1014": "Vista a la colina",
    "1015": "Vista a la laguna",
    "1016": "Lanai",
    "1017": "Vista a un punto emblemático",
    "1018": "Marina / Puerto deportivo",
    "1019": "Vistas múltiples",
    "1020": "Sin vista",
    "1021": "Baño al aire libre",
    "1022": "Zona de comedor al aire libre",
    "1023": "Chimenea exterior",
    "1024": "Muebles de exterior",
    "1025": "Bote",
    "1026": "Zona de entretenimiento al aire libre",
    "1027": "Equipo de deportes acuáticos",
    "1028": "Vista parcial al lago",
    "1029": "Vista parcial",
    "1030": "Porche",
    "1031": "Piso privado en bloque de pisos",
    "1032": "Vista a calle tranquila",
    "1033": "Vista al resort",
    "1034": "Semindependiente / Adosado",
    "1035": "Solárium / Terraza soleada",
    "1036": "Vista al desierto",
    "1037": "Vista parcial al océano",
    "1038": "Vista parcial al mar",
    "1039": "Vista al viñedo",
    "1040": "1 safari fotográfico por noche",
    "1041": "2 safaris fotográficos por noche",
    "1042": "Bingo",
    "1043": "Juegos de mesa / rompecabezas",
    "1044": "Libros",
    "1045": "Crédito para el casino",
    "1046": "Casino cercano",
    "1047": "Conciertos o actuaciones en vivo",
    "1048": "Clase de cocina",
    "1049": "Entradas para parques Disney",
    "1050": "Personal de animación",
    "1051": "Entretenimiento nocturno",
    "1052": "Clases de fitness",
    "1053": "Instalaciones de fitness",
    "1054": "Instalaciones de fitness cercanas",
    "1055": "Vestuarios de spa con fitness",
    "1056": "Pediluvio / Baño de pies",
    "1057": "Pases gratuitos para parque acuático",
    "1058": "Happy hour",
    "1059": "Aguas termales cercanas",
    "1060": "Aguas termales en el lugar",
    "1061": "Baño público cubierto sin aguas minerales",
    "1062": "Piscina infinity",
    "1063": "Bañera de hidromasaje",
    "1064": "Karaoke",
    "1065": "Juegos de azar recreativos",
    "1066": "Biblioteca",
    "1067": "Retransmisión de eventos deportivos en vivo",
    "1068": "Sillón de masaje",
    "1069": "Juego de partido",
    "1070": "Aguas termales minerales cubiertas",
    "1071": "Aguas termales minerales al aire libre",
    "1072": "Noches de cine",
    "1073": "Baño público al aire libre - sin aguas minerales",
    "1074": "Entrenador personal disponible",
    "1075": "Piscina de inmersión",
    "1076": "Bar en la piscina",
    "1077": "Cubierta para piscina",
    "1078": "Toallas de piscina",
    "1079": "Piscina con vistas",
    "1080": "Piscina elevada",
    "1081": "Cabañas junto a la piscina",
    "1083": "Piscina excavada en tierra",
    "1084": "Tumbonas de piscina",
    "1085": "Sombrillas de piscina",
    "1086": "Cascada en la piscina",
    "1087": "Zona de playa privada",
    "1088": "Pub crawls / Rutas de bares",
    "1089": "Baño público",
    "1090": "Piscina en la azotea",
    "1091": "Material de arte",
    "1092": "Instrumentos musicales",
    "1093": "Aguas termales minerales privadas - cubiertas",
    "1094": "Aguas termales minerales privadas - al aire libre",
    "1095": "Piscina de agua salada",
    "1096": "Zona poco profunda de la piscina",
    "1097": "Juego de tragamonedas",
    "1098": "Espectáculo de comedia",
    "1099": "Bar con acceso directo desde la piscina",
    "1100": "Juguetes para piscina",
    "1101": "Telescopio",
    "1102": "Galerías de arte temporales",
    "1103": "Cenas temáticas",
    "1104": "Tour o clase sobre cultura local",
    "1105": "Trampolín",
    "1106": "Visitas guiadas a pie",
    "1107": "Tobogán acuático",
    "1108": "Hidromasaje / Jacuzzi",
    "1109": "Bodega / Viñedo",
    "1110": "Visitas privadas a la bodega en el lugar",
    "1111": "Visitas públicas a la bodega en el lugar",
    "1112": "Eventos de lanzamiento de vino en el lugar",
    "1113": "Sala de cata en la bodega en el lugar",
    "1114": "Visitas a bodegas cercanas",
    "1115": "Viñedo en el lugar",
    "1116": "Clases de yoga",
    "1117": "Crédito para golf",
    "1118": "Compras",
    "1119": "Pista de hielo cercana",
    "1120": "Pista de hielo en el lugar",
    "1121": "Aeróbic",
    "1122": "Tiro con arco en el lugar",
    "1123": "Parques temáticos",
    "1124": "Equipo de bádminton",
    "1125": "Acceso directo a playa privada cercana",
    "1126": "Acceso directo a playa pública cercana",
    "1127": "Cabañas de playa",
    "1128": "Voleibol de playa en el lugar",
    "1129": "Yoga en la playa en el lugar",
    "1130": "Tours en bicicleta",
    "1131": "Ciclismo en carretera cercano",
    "1132": "Observación de aves cercana",
    "1133": "Observación de aves en el lugar",
    "1134": "Canoa en el lugar",
    "1135": "Bote en el lugar",
    "1136": "Bote inflable en el lugar",
    "1137": "Kayak en el lugar",
    "1138": "Bote a pedales en el lugar",
    "1139": "Velero en el lugar",
    "1140": "Paseos en bote cercanos",
    "1141": "Paseos en bote en el lugar",
    "1142": "Exploración de cuevas cercana",
    "1143": "Exploración de cuevas en el lugar",
    "1144": "Ciclismo",
    "1145": "Ecotours cercanos",
    "1146": "Ecotours en el lugar",
    "1147": "Clases de agricultura",
    "1148": "Mesa para limpiar pescado",
    "1149": "Safari fotográfico cercano",
    "1150": "Safari fotográfico en el lugar",
    "1151": "Caminata de caza o avistamiento de fauna cercana",
    "1152": "Caminata de caza o avistamiento de fauna en el lugar",
    "1153": "Avistamiento de fauna cercano",
    "1154": "Avistamiento de fauna en el lugar",
    "1155": "Caddie de golf",
    "1156": "Carrito de golf",
    "1157": "Club de golf / Casa club",
    "1158": "Equipo de golf",
    "1159": "Campo de golf sin campo de prácticas",
    "1160": "Tienda profesional de golf",
    "1161": "Tours en helicóptero o avioneta en el lugar",
    "1162": "Senderismo",
    "1163": "Senderismo y ciclismo cercanos",
    "1164": "Senderismo y ciclismo en el lugar",
    "1165": "Caza cercana",
    "1166": "Caza en el lugar",
    "1167": "Kayak cercano",
    "1168": "Kayak en el lugar",
    "1169": "Río lento",
    "1170": "Bote a motor cercano",
    "1171": "Bote a motor en el lugar",
    "1172": "Escalada de montaña cercana",
    "1173": "Moto de agua cercana",
    "1174": "Moto de agua en el lugar",
    "1175": "Rafting cercano",
    "1176": "Rafting en el lugar",
    "1177": "Circuito de cuerdas para team building en el lugar",
    "1178": "Remo o piragüismo en el lugar",
    "1179": "Safari cercano",
    "1180": "Safari en el lugar",
    "1181": "Buceo cercano",
    "1182": "Paracaidismo cercano",
    "1183": "Paracaidismo en el lugar",
    "1184": "Snorkel cercano",
    "1185": "Surf o boogieboarding cercano",
    "1186": "Surf o boogieboarding en el lugar",
    "1187": "Equipo de tenis",
    "1188": "Clases de tenis en el lugar",
    "1189": "Camino al agua",
    "1191": "Parque acuático",
    "1192": "Esquí acuático cercano",
    "1193": "Tubing acuático cercano",
    "1194": "Windsurf cercano",
    "1195": "Tirolina cercana",
    "1196": "Tirolina en el lugar",
    "1197": "Tipo de arena de playa: arena",
    "1198": "Tipo de arena de playa: arena negra",
    "1199": "Tipo de arena de playa: arena blanca",
    "1201": "Inodoro a altura accesible",
    "1202": "Acceso sin escalones al baño",
    "1203": "Puerta ancha de baño",
    "1204": "Acceso sin escalones al dormitorio",
    "1205": "Puerta ancha de dormitorio",
    "1206": "Grúa de techo",
    "1207": "Acceso sin escalones a espacios comunes",
    "1208": "Puerta ancha de espacios comunes",
    "1209": "Plaza de aparcamiento para discapacitados",
    "1210": "Cama eléctrica articulada",
    "1211": "Botiquín de primeros auxilios",
    "1212": "Cabezal de ducha de mano",
    "1213": "Acceso sin escalones al hogar",
    "1214": "Puerta ancha de entrada al hogar",
    "1215": "Cerradura en la puerta del dormitorio",
    "1216": "Grúa móvil",
    "1217": "Camino a la entrada iluminado por la noche",
    "1218": "Elevador de piscina",
    "1219": "Entrada privada",
    "1220": "Ducha abierta (sin bordillo)",
    "1221": "Silla de ducha",
    "1222": "Bañera con asiento de ducha",
    "1223": "Amplio espacio alrededor de la cama",
    "1224": "Amplio espacio alrededor de ducha e inodoro",
    "1225": "Amplio espacio en pasillos",
    "1226": "Baño accesible",
    "1227": "Aparcamiento accesible",
    "1228": "Camino de acceso accesible",
    "1229": "Bañera adaptada",
    "1230": "Guía auditiva",
    "1231": "Cuerda de emergencia en el baño",
    "1232": "Barandillas para cama",
    "1233": "Cierres de seguridad en armarios",
    "1234": "Protecciones de esquinas",
    "1235": "Acceso con tarjeta electrónica",
    "1237": "Toda la propiedad en planta baja",
    "1238": "Equipo para personas sordas",
    "1239": "Caja fuerte para portátil",
    "1240": "Lavabo bajo",
    "1241": "Contacto de emergencia médica",
    "1242": "Acceso con llaves metálicas",
    "1243": "Contacto de emergencia policial",
    "1244": "Puerta de seguridad en piscina",
    "1245": "Caja fuerte con capacidad para portátil",
    "1246": "Sistema de seguridad en la habitación",
    "1248": "Planta superior accesible solo por escaleras",
    "1249": "Ayudas visuales: braille",
    "1250": "Ayudas visuales: señales táctiles",
    "1251": "Protectores de ventanas",
    "1252": "Seguridad: advertencia de balcón",
    "1253": "Seguridad: propiedad totalmente cercada",
    "1254": "Capilla o santuario",
    "1255": "Habitaciones familiares",
    "1256": "Suite nupcial",
    "1257": "Habitaciones insonorizadas",
    "1258": "2 baños",
    "1259": "Baño privado en suite",
    "1260": "Baño privado",
    "1261": "Baño compartido",
    "1262": "Cocina completa",
    "1263": "Vestidor",
    "1264": "Habitaciones comunicadas disponibles",
    "1265": "Escritorio grande",
    "1266": "Zona de estar",
    "1267": "Escritorio con toma de corriente",
    "1268": "Armarios en la habitación",
    "1269": "Silla con escritorio",
    "1270": "Asientos en el comedor",
    "1271": "Múltiples armarios",
    "1272": "Área de asientos",
    "1273": "Suelo alfombrado",
    "1274": "Zona de comedor",
    "1276": "Perchero / Barra para ropa",
    "1277": "Decoración de la habitación",
    "1278": "Limpieza antes de la salida",
    "1282": "Limpieza diaria",
    "1283": "Limpieza una vez por estancia",
    "1284": "Limpieza solo los fines de semana",
    "1285": "Limpieza solo entre semana",
    "1286": "Servicio de habitaciones limitado",
    "1287": "Servicio de habitaciones genérico",
    "1288": "Bufé 2x1",
    "1289": "Todas las comidas",
    "1290": "Todo incluido",
    "1291": "Bar de playa",
    "1292": "Desayuno para 1",
    "1293": "Desayuno para 2",
    "1294": "Desayuno en la habitación",
    "1295": "Galletas de chocolate",
    "1296": "Cafetera / Tetera",
    "1297": "Recepción de vino de cortesía",
    "1298": "Desayuno continental para 2",
    "1299": "Cena para parejas",
    "1300": "Bebidas y aperitivos",
    "1301": "Crédito para comida y bebida",
    "1302": "Desayuno gratuito para 1 adulto",
    "1303": "Cena gratuita para 1 adulto",
    "1304": "Bebida de bienvenida gratuita",
    "1305": "Pensión completa",
    "1306": "Supermercado",
    "1307": "Media pensión",
    "1308": "Mini nevera",
    "1309": "Cafetería en el lugar",
    "1310": "Almuerzos para llevar",
    "1311": "Nevera con máquina de hielo",
    "1312": "Solo servicio de comedor en la habitación",
    "1313": "Snack bar",
    "1314": "Menús para dietas especiales bajo petición",
    "1315": "Servicio de té",
    "1319": "Copas de vino",
    "1320": "Vino y champán",
    "1321": "Bañera para bebé",
    "1322": "Cambiador",
    "1323": "Libros y juguetes para niños",
    "1324": "Vajilla infantil",
    "1325": "Protectores de chimenea",
    "1326": "Protectores de enchufes",
    "1327": "Cortinas opacas",
    "1328": "Puertas de seguridad para escaleras",
    "1329": "Protectores de esquinas de mesa",
    "1330": "Puertas de seguridad para bebés",
    "1331": "Juegos de mesa / rompecabezas",
    "1332": "Biblioteca infantil de libros, DVD y música",
    "1333": "Canales de televisión infantiles",
    "1334": "Juegos infantiles",
    "1335": "Juguetes de entretenimiento",
    "1336": "Zona de juegos cubierta",
    "1337": "Juguetes para bebés y niños pequeños",
    "1338": "Comidas para niños",
    "1339": "Equipo de juego exterior para niños",
    "1340": "Vajilla infantil",
    "1341": "Cuidado de niños",
    "1342": "Zapatillas de niño",
    "1344": "Cama extra grande doble",
    "1345": "Camas extra largas de 2 metros",
    "1346": "Colchón futón",
    "1347": "Cama doble grande",
    "1348": "Edredón nórdico de plumas",
    "1349": "Cama hipoalergénica disponible",
    "1350": "Cama a altura accesible",
    "1352": "Elementos básicos de cocina",
    "1353": "Suministros de cocina",
    "1354": "Zona de cocina y comedor",
    "1355": "Utensilios de cocina",
    "1356": "Microondas compartido (no en la habitación)",
    "1357": "Nevera con microondas",
    "1358": "Molino de café",
    "1359": "Plancha / Griddle",
    "1360": "Olla para langosta",
    "1361": "Batidora / Mezcladora",
    "1362": "Especias",
    "1363": "Fogones",
    "1364": "Gofrera",
    "1366": "Videoteca de entretenimiento",
    "1367": "Películas / videos gratis",
    "1368": "Películas de pago por visión en TV",
    "1369": "Lista de canales de películas disponibles",
    "1370": "CNN disponible",
    "1371": "Reproductor de Blu-ray",
    "1372": "Canales de pago por visión",
    "1373": "Películas de estreno",
    "1374": "Canales de TV premium",
    "1375": "Servicio de streaming como Netflix",
    "1376": "Vídeo bajo demanda",
    "1377": "Incluye una película gratuita en la habitación",
    "1378": "Portátil",
    "1379": "Teléfono de texto TDD",
    "1380": "Teléfono multilínea",
    "1381": "Teléfono para personas con discapacidad auditiva",
    "1382": "Teléfono de dos líneas",
    "1383": "Radio por satélite",
    "1384": "Teléfonos móviles / celulares disponibles",
    "1385": "iPad",
    "1386": "Consola de juegos Xbox 360",
    "1387": "Consola de juegos PlayStation 2",
    "1388": "Consola de juegos PlayStation 3",
    "1389": "Consola de juegos Nintendo Wii",
    "1390": "Consola de juegos Xbox One",
    "1391": "Consola de juegos Wii U",
    "1392": "Consola de juegos PlayStation 4",
    "1393": "Smartphone disponible",
    "1394": "Cargador para vehículo eléctrico",
    "1395": "Asistencia para tours",
    "1396": "Sábanas italianas Frette",
    "1397": "Colchón premium",
    "1398": "Acceso a sala VIP de negocios",
    "1399": "Llamadas gratuitas disponibles",
    "1400": "Servicio de champán",
    "1401": "Tiendas de lujo",
    "1402": "Acceso gratuito al centro de fitness",
    "1403": "Acceso gratuito al centro de negocios",
    "1404": "Acceso VIP a discotecas",
    "1406": "Ropa de baño",
    "1407": "Bañera con chorros de hidromasaje",
    "1408": "Solo bañera",
    "1409": "Bañera estilo grecorromano",
    "1410": "Solo ducha",
    "1411": "Bañera y jacuzzi separados",
    "1412": "Bañera de gran tamaño",
    "1413": "Bañera y ducha separadas",
    "1414": "Zona de inodoro separada",
    "1415": "Baño de spa",
    "1417": "Aseo de cortesía",
    "1418": "Aseo adicional",
    "1419": "Baño adicional",
    "1420": "Cepillo de dientes",
    "1421": "Gorro de ducha",
    "1422": "Baño compartido con lavabo",
    "1424": "Baño exterior parcialmente abierto",
    "1425": "Albomoz de niño",
    "1426": "Bidé electrónico",
    "1427": "Artículos de aseo de diseñador",
    "1428": "Sandalias Geta",
    "1429": "Bañera de spa privada",
    "1430": "Bañera de inmersión profunda",
    "1431": "Bañera con agua de manantial en la habitación",
    "1432": "Bañera para bebé con cabezal de ducha tipo lluvia",
    "1433": "Toallas de papel",
    "1434": "Secador de pelo bajo petición",
    "1435": "Detergente para lavadora",
    "1436": "Ropa de cama",
    "1437": "Almohadas y mantas adicionales",
    "1438": "Mantas eléctricas",
    "1439": "Pijamas",
    "1440": "Yukata",
    "1441": "Enchufe cerca de la cama",
    "1442": "Almohadas de plumas",
    "1443": "Almohadas sin plumas",
    "1444": "Almohadas hipoalergénicas",
    "1445": "Menú de almohadas",
    "1446": "Privilegios opcionales de telesilla",
    "1447": "Snowboard en el lugar",
    "1448": "Trineo cercano",
    "1449": "Trineo en el lugar",
    "1450": "Tubing de nieve cercano",
    "1451": "Tubing de nieve en el lugar",
    "1452": "Motonieve cercana",
    "1453": "Motonieve en el lugar",
    "1454": "Raquetas de nieve cercanas",
    "1455": "Raquetas de nieve en el lugar",
    "1456": "Zona de esquí cercana",
    "1457": "Teleféricos cercanos",
    "1458": "Pistas de esquí cercanas",
    "1459": "Clases de esquí cercanas",
    "1460": "Clases de esquí en el lugar",
    "1461": "Privilegios de telesilla",
    "1462": "Pases de esquí",
    "1463": "Alquiler de esquís cercano",
    "1464": "Alquiler de esquís en el lugar",
    "1465": "Equipo de deportes de nieve",
    "1466": "Descensos cercanos",
    "1467": "Descensos en el lugar",
    "1468": "Escuela de esquí",
    "1469": "Alquiler de equipo de esquí en el lugar",
    "1470": "Vendedor de pases de esquí",
    "1471": "Transporte a pistas de esquí",
    "1472": "Acceso directo a pistas de esquí",
    "1473": "Alquiler gratuito de forfait",
    "1475": "Transporte a pistas de esquí cercano",
    "1476": "Piscina comunal de spa",
    "1477": "Bañera de hidromasaje de spa",
    "1478": "Piscina privada de spa",
    "1479": "Aromaterapia",
    "1480": "Ayurvédico",
    "1481": "Exfoliaciones corporales",
    "1483": "Envolturas corporales",
    "1485": "Hidroterapia",
    "1486": "Habitaciones de spa para parejas",
    "1487": "Zona de tratamiento al aire libre",
    "1488": "Talasoterapia",
    "1489": "Baño turco",
    "1490": "Envoltura de desintoxicación",
    "1491": "Reflexología",
    "1492": "Aguas termales",
    "1493": "Sauna en el spa",
    "1494": "Baño de barro en el spa",
    "1495": "Bañera de hidromasaje en el spa",
    "1496": "Baño de vapor en el spa",
    "1497": "Manicura y pedicura",
    "1498": "Pilates en el lugar",
    "1499": "Masaje - se requiere reserva anticipada",
    "1500": "Masaje en la playa",
    "1501": "Masaje de tejido profundo",
    "1502": "Masaje con piedras calientes",
    "1503": "Masaje prenatal",
    "1504": "Masaje deportivo",
    "1505": "Masaje sueco",
    "1506": "Masaje tailandés",
    "1507": "Instalaciones de spa",
    "1508": "Zona de relax del spa",
    "1509": "Paquetes de bienestar en el spa",
    "1510": "Masaje de espalda",
    "1511": "Masaje de cuello",
    "1512": "Masaje de pies",
    "1513": "Masaje en pareja",
    "1514": "Masaje de cabeza",
    "1515": "Masaje de manos",
    "1516": "Masaje corporal completo",
    "1517": "Peluquero / Esteticista",
    "1518": "Tratamientos faciales",
    "1519": "Servicios de depilación",
    "1520": "Servicios de maquillaje",
    "1521": "Tratamientos capilares",
    "1522": "Manicura",
    "1523": "Pedicura",
    "1524": "Corte de pelo",
    "1525": "Tinte de pelo",
    "1526": "Peinado",
    "1527": "Tratamientos corporales",
    "1528": "Exfoliación corporal",
    "1529": "Fototerapia",
    "1530": "Crédito para spa",
    "1538": "Alojamiento otros servicios coche disponible",
    "1539": "Estación de carga para coches eléctricos",
    "1540": "Alquiler de scooters o ciclomotores cercano",
    "1541": "Alquiler de scooters o ciclomotores en el lugar",
    "1542": "Servicio de transporte al aeropuerto con recargo",
    "1543": "Billetes de transporte público",
    "1544": "Check-in y check-out privados",
    "1545": "Traslado gratuito de regreso al aeropuerto",
    "1546": "Aparcamiento con plazas limitadas",
    "1547": "Tour en Segway cercano",
    "1548": "Tour en Segway en el lugar",
    "1549": "Bajada en transporte al aeropuerto gratuita",
    "1550": "Bajada en transporte al aeropuerto con recargo",
    "1551": "Recogida en transporte del aeropuerto gratuita",
    "1552": "Recogida en transporte del aeropuerto con recargo",
    "1553": "Transporte de ida y vuelta al aeropuerto gratuito",
    "1554": "Transporte de ida y vuelta al aeropuerto con recargo",
    "1555": "Servicio de transporte al aeropuerto genérico",
    "1556": "Servicio de transporte al aeropuerto disponible 24 horas",
    "1557": "Sin servicio de transporte al aeropuerto",
    "1558": "Transporte al aeropuerto - horario limitado",
    "1559": "Transporte al aeropuerto - disponible bajo petición",
    "1560": "Tarifa de transporte al aeropuerto para adultos disponible en horarios programados",
    "1561": "Tarifa de transporte al aeropuerto para adultos contactar con el establecimiento antes de la llegada",
    "1562": "Tarifa de transporte al aeropuerto para adultos importe de la tarifa",
    "1563": "Transporte en la zona gratuito",
    "1564": "Transporte en la zona con recargo por distancia",
    "1565": "Transporte en la zona genérico",
    "1566": "Transporte a la playa gratuito",
    "1567": "Transporte a la playa con recargo",
    "1568": "Transporte al centro comercial gratuito",
    "1569": "Transporte al centro comercial con recargo",
    "1570": "Transporte al casino gratuito",
    "1571": "Transporte al casino con recargo",
    "1572": "Transporte al parque temático gratuito",
    "1573": "Transporte al parque temático con recargo",
    "1574": "Transporte a la terminal de cruceros gratuito",
    "1575": "Transporte a la terminal de cruceros con recargo",
    "1576": "Transporte a la terminal de ferry con recargo",
    "1577": "Transporte a la terminal de ferry contactar con el establecimiento antes de la llegada",
    "1578": "Transporte a la terminal de ferry gratuito",
    "1579": "Servicio de recogida en estación de tren con recargo",
    "1580": "Servicio de recogida en estación de tren contactar con el establecimiento antes de la llegada",
    "1581": "Servicio de recogida en estación de tren gratuito",
    "1582": "Horario de transporte a la estación con recargo",
    "1583": "Horario de transporte a la estación disponible 24 horas",
    "1584": "Horario de transporte a la estación disponible en horarios programados",
    "1585": "Horario de transporte a la estación disponible con horario limitado",
    "1586": "Horario de transporte a la estación disponible bajo petición",
    "1587": "Debe contactar con el establecimiento para recogida/descenso gratuito",
    "1588": "Debe contactar con el establecimiento para recogida/descenso con recargo",
    "1589": "Debe contactar con el establecimiento para recogida a la llegada",
    "1590": "Debe contactar con el establecimiento para recogida 24 horas antes de la llegada",
    "1592": "Debe contactar con el establecimiento para recogida 48 horas antes de la llegada",
    "1593": "Debe contactar con el establecimiento para recogida 72 horas antes de la llegada",
    "1594": "Comedor snack bar o delicatessen",
    "1595": "Menú infantil",
    "1596": "Cocina afgana",
    "1597": "Cocina africana",
    "1598": "Cocina americana",
    "1599": "Cocina argentina",
    "1600": "Cocina asiática",
    "1601": "Cocina barbacoa",
    "1602": "Cocina vasca",
    "1603": "Cocina belga",
    "1604": "Cocina brasileña",
    "1605": "Cocina británica",
    "1606": "Cocina birmana",
    "1607": "Cocina cajún o criolla",
    "1608": "Cocina californiana",
    "1609": "Cocina camboyana",
    "1610": "Cocina caribeña",
    "1611": "Cocina china",
    "1612": "Cocina cubana",
    "1613": "Cocina dim sum",
    "1614": "Cocina de Europa del Este",
    "1615": "Cocina eritrea",
    "1616": "Cocina etíope",
    "1617": "Cocina filipina",
    "1618": "Cocina de pescado y patatas fritas",
    "1619": "Cocina fondue",
    "1620": "Cocina francesa",
    "1621": "Cocina fusión",
    "1622": "Cocina alemana",
    "1623": "Cocina griega",
    "1624": "Cocina halal",
    "1625": "Cocina hawaiana",
    "1626": "Cocina del Himalaya",
    "1627": "Cocina húngara",
    "1628": "Cocina indfivesian",
    "1629": "Cocina india",
    "1630": "Cocina internacional",
    "1631": "Cocina irlandesa",
    "1632": "Cocina italiana",
    "1633": "Cocina japonesa",
    "1634": "Cocina coreana",
    "1635": "Cocina kosher",
    "1636": "Cocina laosiana",
    "1637": "Cocina viva o cruda",
    "1638": "Cocina local",
    "1639": "Cocina local e internacional",
    "1640": "Cocina malasia",
    "1641": "Cocina mediterránea",
    "1642": "Cocina mexicana",
    "1643": "Cocina de Oriente Medio",
    "1644": "Cocina moderna europea",
    "1645": "Cocina mongola",
    "1646": "Cocina marroquí",
    "1647": "Cocina pakistaní",
    "1648": "Cocina panasiática",
    "1649": "Cocina persa / iraní",
    "1650": "Cocina peruana",
    "1651": "Cocina pizza",
    "1652": "Cocina polaca",
    "1653": "Cocina portuguesa",
    "1654": "Cocina regional",
    "1655": "Cocina rusa",
    "1656": "Cocina escandinava",
    "1657": "Cocina de mariscos",
    "1658": "Cocina singapurense",
    "1659": "Cocina soul food",
    "1660": "Cocina sureña",
    "1661": "Cocina española",
    "1662": "Cocina sushi",
    "1663": "Cocina taiwanesa",
    "1664": "Cocina tex-mex",
    "1665": "Cocina tailandesa",
    "1666": "Cocina turca",
    "1667": "Cocina ucraniana",
    "1668": "Cocina vegana",
    "1669": "Cocina vegetariana",
    "1670": "Cocina vietnamita",
    "1671": "Tiene bar",
    "1672": "Ubicación al aire libre",
    "1673": "Ubicación frente a la playa",
    "1674": "Ubicación con vistas al jardín",
    "1675": "Ubicación con vistas al golf",
    "1676": "Ubicación con vistas al océano",
    "1677": "Ubicación con vistas a la piscina",
    "1678": "Ubicación junto a la piscina",
    "1680": "Brunch",
    "1683": "Comida ligera",
    "1685": "Se requiere reserva",
    "1686": "Bistró",
    "1687": "Brasserie",
    "1688": "Bufé",
    "1689": "Cafetería",
    "1691": "Tienda de delicatessen",
    "1692": "Comedor / Diner",
    "1693": "Restaurante familiar",
    "1694": "Alta cocina",
    "1695": "Pub",
    "1697": "Mariscos",
    "1698": "Steakhouse",
    "1699": "Sushi bar",
    "1700": "Tapas",
    "1701": "Temático",
    "1702": "Tema de propiedad: deportes de aventura",
    "1703": "Tema de propiedad: playa",
    "1704": "Tema de propiedad: negocios",
    "1705": "Tema de propiedad: casino",
    "1706": "Tema de propiedad: familiar",
    "1707": "Tema de propiedad: golf",
    "1708": "Tema de propiedad: aguas termales",
    "1709": "Tema de propiedad: esquí",
    "1710": "Tema de propiedad: spa",
    "1711": "Tema de propiedad: romántico",
    "1712": "Tema de propiedad: bodega",
    "1713": "Tema de propiedad: ciudad",
    "1714": "Tema de propiedad: naturaleza",
    "1715": "Tema de propiedad: compras",
    "1716": "Diseño de propiedad: barroco",
    "1717": "Diseño de propiedad: bellas artes",
    "1718": "Diseño de propiedad: belle époque",
    "1719": "Diseño de propiedad: colonial",
    "1720": "Diseño de propiedad: art déco",
    "1721": "Diseño de propiedad: eduardiano",
    "1722": "Diseño de propiedad: georgiano",
    "1723": "Diseño de propiedad: mediterráneo",
    "1724": "Diseño de propiedad: tradicional",
    "1725": "Diseño de propiedad: Tudor",
    "1726": "Diseño de propiedad: toscano",
    "1727": "Diseño de propiedad: victoriano",
    "1728": "Aparcamiento requiere reserva",
    "1729": "Cobertura de internet en áreas públicas",
    "1730": "Cobertura de internet en todas las habitaciones",
    "1731": "Cobertura de internet en algunas habitaciones",
    "1732": "Cobertura de internet en el centro de negocios",
    "1733": "Se permiten fiestas",
    "1734": "Vista al patio interior",
    "1735": "No se permite fumar",
    "1736": "Apto para bebés",
    "1741": "Se requiere identificación del huésped al hacer el check-in",
    "1742": "No se permiten huéspedes con tatuajes",
    "1743": "Solo zona peatonal",
    "1744": "Acceso por camino sin pavimentar",
    "1745": "Zona residencial",
    "1746": "Zona concurrida",
    "1747": "Se requiere identificación del huésped",
    "1748": "No se permiten tatuajes",
    "1749": "Zona peatonal",
    "1750": "Acceso por camino sin pavimentar",
    "1751": "Zona residencial",
    "1752": "Zona concurrida",
    "1753": "Prácticas de limpieza mejoradas",
    "1754": "Limpieza realizada por empresas de limpieza profesionales",
    "1755": "Uso de desinfectantes para la limpieza",
    "1756": "Uso de productos químicos de limpieza eficaces contra el Coronavirus",
    "1757": "Distanciamiento social siguiendo las pautas de las autoridades locales",
    "1758": "Proceso para controlar la salud de los huéspedes",
    "1759": "Mascarillas disponibles",
    "1760": "Gel hidroalcohólico disponible",
    "1761": "Pantallas o barreras físicas entre el personal y los huéspedes en áreas designadas",
    "1762": "Check-in y check-out sin contacto disponible.",
    "1763": "Check-in sin contacto disponible",
    "1764": "Check-out sin contacto disponible",
    "1765": "El personal sigue todos los protocolos de seguridad de las autoridades locales",
    "1766": "La ropa de cama, toallas y ropa se lavan según las pautas de las autoridades locales",
    "1767": "Ropa de cama y toallas lavadas al menos a 60°C/140°F",
    "1768": "Platos, cubettería, vasos y otros utensilios de mesa desinfectados",
    "1769": "Superficies de alto contacto desinfectadas",
    "1770": "Alojamiento de los huéspedes sellado después de la limpieza",
    "1771": "Se puede evitar la limpieza del alojamiento de los huéspedes a petición",
    "1772": "El personal usa equipo de protección personal",
    "1773": "Controles de temperatura al personal",
    "1774": "La propiedad está vacía durante al menos 24 horas entre reservas.",
    "1775": "La propiedad está vacía durante al menos 48 horas entre reservas.",
    "1776": "La propiedad está vacía durante al menos 72 horas entre reservas.",
    "1777": "Se requiere documentación adicional relacionada con COVID-19",
    "1778": "No se admiten huéspedes de ciertos países",
    "1779": "Guantes disponibles para los huéspedes",
    "1780": "Se retiraron artículos de papelería compartidos (menús impresos, bolígrafos, papel)",
    "1781": "Botiquín de primeros auxilios disponible",
    "1782": "Pago sin efectivo disponible",
    "1783": "Propiedad disponible solo para viajeros esenciales de COVID-19",
    "1784": "Horario de servicio reducido",
    "1785": "Spa y gimnasio no disponibles",
    "1786": "Servicios en el lugar reducidos",
    "1787": "Servicio de transporte suspendido",
    "1788": "Distanciamiento social en las áreas de comedor",
    "1789": "Opciones de comida en la habitación disponibles",
    "1790": "Servicios de comida reducidos",
    "1791": "Comida para el desayuno envuelta individualmente",
    "1792": "Comida para el almuerzo envuelta individualmente",
    "1793": "Comida para la cena envuelta individualmente",
    "1794": "Comida envuelta individualmente en el servicio de habitaciones",
    "1795": "Aplicación móvil para servicio de habitaciones",
    "1796": "Se sigue el protocolo de desinfección Singapore SG Clean",
    "1797": "Se sigue el protocolo de desinfección Malaysia Safe & Clean",
    "1798": "Se sigue el protocolo de desinfección South Korea CESCO",
    "1799": "Se sigue el protocolo de desinfección Thailand Safety and Health Administration",
    "1801": "Se sigue el protocolo de desinfección Portugal Clean & Safe",
    "1802": "Se sigue el protocolo de desinfección del Ministerio de Industria, Comercio y Turismo de España",
    "1803": "Se sigue el protocolo de desinfección de la Confederación Española de Hoteles y Alojamientos Turísticos de España",
    "1804": "Se sigue el protocolo de desinfección National Protocol Accoglienza Sicura (Safe Hospitality) de Italy Federalberghi",
    "1805": "Se sigue el protocolo de desinfección Brazil Protected Tourist",
    "1807": "La propiedad sigue las prácticas de desinfección del Protocolo Sanitario (UNPLV - Francia)",
    "1809": "La propiedad sigue las prácticas de desinfección de SafeStay (AHLA - EE. UU.)",
    "1810": "La propiedad sigue la guía para la reapertura de alquileres vacacionales (DTV y DFV - Alemania)",
    "1811": "La propiedad sigue las prácticas de desinfección de la Asociación Europea de Viviendas Vacacionales (EHHA - Europa)",
    "1812": "La propiedad sigue las prácticas de desinfección de Intertek Cristal (experto externo - Global)",
    "1813": "La propiedad sigue las prácticas de desinfección de Safe Travels (WTTC - Global)",
    "1814": "La propiedad sigue las prácticas de desinfección de la Asociación de Turismo de Croacia (HUT - Croacia)",
    "1815": "La propiedad sigue las prácticas de desinfección de SafeHome (VRMA y VRHP)",
    "1817": "Check-in presencial",
    "1818": "Check-in con cajas de seguridad y cajas fuertes con llave",
    "1819": "Check-in con teclado numérico",
    "1820": "El huésped debe contactarnos para obtener instrucciones",
    "1821": "Lavadora - espacio común",
    "1822": "Secadora - espacio común",
    "1823": "Cuna de viaje",
    "1825": "Futón doble",
    "1826": "Airbnb: Todos pueden hacer reserva instantánea",
    "1827": "Airbnb: Huéspedes con buenas reseñas pueden hacer reserva instantánea",
    "1828": "Airbnb: Huéspedes con identidad verificada pueden hacer reserva instantánea",
    "1829": "Airbnb: Solo huéspedes con buenas reseñas e identidad verificada pueden hacer reserva instantánea",
    "1830": "Escaleras",
    "1831": "Ruido potencial",
    "1832": "Mascotas en la propiedad",
    "1833": "Aparcamiento limitado",
    "1834": "Espacios compartidos",
    "1835": "Servicios limitados",
    "1836": "Armas en la propiedad",
    "1837": "Animales peligrosos",
    "1838": "Acondicionador",
    "1839": "Ducha de lluvia",
    "1840": "Gel de ducha",
    "1841": "Cualquiera de los siguientes: ropero, armarios, vestidor separado",
    "1842": "Equipo de ejercicio",
    "1843": "Tocadiscos",
    "1844": "Bandeja de horno",
    "1845": "Máquina de hacer pan",
    "1846": "Café",
    "1847": "Arrocera",
    "1848": "Triturador de basura",
    "1849": "Lavandería automática cercana",
    "1850": "Acceso al resort",
    "1851": "Amarre para bote",
    "1852": "Hamaca",
    "1853": "Asientos al aire libre",
    "1854": "Cocina al aire libre",
    "1855": "Aparcamiento de pago en las instalaciones",
    "1856": "Estancias largas",
    "1857": "Baño compartido con otros huéspedes",
    "1858": "Baño compartido con el anfitrión",
    "1859": "Baño compartido con familia, amigos, compañeros de piso",
    "1860": "Espacios comunes compartidos con otros huéspedes",
    "1861": "Espacios comunes compartidos con el anfitrión",
    "1862": "Espacios comunes compartidos con familia, amigos, compañeros de piso",
    "1863": "Cámaras de vigilancia en la propiedad",
    "1864": "Equipo de fitness",
    "1865": "Colchón de aire",
    "1866": "Colchón en el suelo",
    "1867": "Barbacoa de gas",
    "1868": "Barbacoa de carbón",
    "1869": "Ubicación frente al océano",
    "1870": "Tarifa de chef",
    "1871": "Chef bajo petición",
    "1873": "Máx. 1 mascota permitida",
    "1874": "Máx. 2 mascotas permitidas",
    "1875": "Máx. 3 mascotas permitidas",
    "1876": "Máx. 4 mascotas permitidas",
    "1877": "Máx. 5 mascotas permitidas",
    "1878": "Tarea de salida: Devolver llaves al hacer el checkout",
    "1879": "Tarea de salida: Apagar luces/electrodomésticos al irse",
    "1880": "Tarea de salida: Encargarse de la basura antes de irse",
    "1881": "Tarea de salida: Cerrar las puertas al irse",
    "1882": "Tarea de salida: Dejar las toallas en un lugar específico",
    "1883": "Tarea de salida: Apagar luces y aire acondicionado",
    "1884": "Tarea de salida: Apagar ventiladores y aparatos electrónicos",
    "1885": "Tarea de salida: Apagar luces y cerrar ventanas",
    "1886": "Tarea de salida: Cerrar ventanas y puertas",
    "1887": "Tarea de salida: Cerrar y devolver la llave",
    "1888": "Tarea de salida: Cerrar puerta y balcón y devolver la llave",
    "1889": "Tarea de salida: Reunir toallas y ropa de cama en la bolsa de ropa",
    "1890": "Tarea de salida: Dejar las toallas en el baño",
    "1891": "Tarea de salida: Reunir toallas y ropa de cama",
    "1892": "Tarea de salida: Limpiar los platos",
    "1893": "Tarea de salida: Sacar la comida de la nevera",
    "1894": "Tarea de salida: Vaciar la basura y poner el lavavajillas",
    "1895": "Tarea de salida: La propiedad sucia conllevará un cargo de limpieza",
    "1897": "Tarea de salida: Desechar la basura en contenedores o vertederos",
    "1898": "Tarea de salida: Instrucciones de reciclaje",
    "1899": "Tarea de salida: Vertederos de basura en pisos específicos",
    "1900": "Tarea de salida: Contenedores/vertederos fuera de la propiedad",
    "1901": "Tarea de salida: Métodos de eliminación en el manual de la casa",
    "1902": "Tarea de salida: Dejar las llaves en la mesa",
    "1904": "Tarea de salida: Dejar las llaves en la caja de seguridad",
    "1905": "Tarea de salida: Dejar las llaves en el llavero de seguridad",
    "1906": "Tarea de salida: Dejar las llaves en la cocina",
    "1907": "Tarea de salida: Dejar las llaves al personal o seguridad",
    "1908": "Solo animales de servicio",
    "1909": "Aparcamiento para bicicletas"
};

window.__pt.ln.amenityaccommodation = {
    "2": "Utensilios de cocina",
    "3": "Vajilla y cubettería",
    "4": "Plancha y tabla de planchar",
    "5": "Tendedero",
    "6": "Secador de pelo",
    "7": "Ropa de cama y toallas",
    "8": "Artículos de aseo",
    "9": "Calefacción central",
    "11": "Lavadora",
    "13": "Lavavajillas",
    "17": "Hervidor de agua",
    "19": "TV por cable",
    "21": "Despertador",
    "22": "Equipo de música",
    "23": "DVD",
    "24": "Reproductor de CD",
    "25": "Reproductor de video (VHS)",
    "27": "También hay un segundo baño separado",
    "29": "Bidé",
    "32": "Armario",
    "33": "Armario de tocador",
    "35": "Baño jacuzzi con ducha",
    "36": "Lavabo con espejo",
    "37": "Inodoro",
    "46": "Plato de ducha",
    "50": "Cuarto de ducha",
    "52": "Bañera con ducha",
    "53": "WC",
    "55": "Cuna para bebé",
    "56": "Opcional: trona para bebé",
    "58": "Radiadores",
    "61": "Cama doble / matrimonio",
    "63": "Opcional: cuna y trona para bebé",
    "66": "Armarios empotrados",
    "69": "Roperos",
    "70": "Mesita de noche",
    "71": "Mesitas de noche",
    "72": "Lámparas de lectura",
    "73": "Escritorio",
    "74": "Televisor",
    "78": "Cómoda",
    "79": "Baño/WC",
    "81": "Baño",
    "82": "Baños",
    "87": "Dormitorios",
    "89": "Balcón",
    "91": "Pequeña terraza",
    "92": "Invernadero con mesa y sillas",
    "93": "Terrazas",
    "94": "Cocina en salón / comedor",
    "96": "Balcón pequeño",
    "97": "Recibidor",
    "98": "Pasillo",
    "99": "Salón",
    "100": "Terraza",
    "101": "Cocina",
    "102": "Cocina moderna",
    "106": "Estanterías para libros",
    "110": "Fogones con horno",
    "114": "Fogones",
    "115": "Horno",
    "118": "Estilo moderno",
    "119": "Cocina económica",
    "123": "Hervidor eléctrico",
    "124": "Microondas",
    "125": "Tostadora",
    "127": "Estilo tradicional",
    "128": "Platos",
    "129": "Ollas y sartenes",
    "130": "Nevera / congelador",
    "131": "Nevera",
    "133": "Mini tabla de planchar",
    "134": "Lavadora secadora",
    "135": "Cocina totalmente equipada",
    "137": "Lavadora secadora de ropa",
    "140": "Cafetera",
    "142": "Escurreplatos",
    "143": "Aspiradora",
    "144": "Tetera",
    "146": "Fogones de gas/eléctricos",
    "147": "Horno eléctrico",
    "150": "Barra de desayuno con taburetes",
    "151": "Mesa y sillas de cocina",
    "152": "Congelador",
    "157": "Kitchenette",
    "161": "Sillones",
    "163": "Mesa de centro",
    "166": "TV (solo canales locales)",
    "167": "TV vía satélite",
    "174": "Conexión a internet",
    "180": "Aire acondicionado",
    "181": "Aire acondicionado / calefacción",
    "182": "Sofá",
    "186": "Unidad de aire acondicionado portátil",
    "187": "Calefacción",
    "188": "Lámpara",
    "189": "Mesa y sillas",
    "192": "Sofá de cuero",
    "193": "Sillón con reposapiés",
    "197": "Estantes",
    "198": "Radio",
    "199": "Ordenador con acceso gratuito a internet (ASDL)",
    "200": "Sofá cama doble",
    "201": "Armario",
    "203": "Sofá doble",
    "204": "Salón confortable en el lugar",
    "205": "Mostrador de ayuda",
    "208": "Tronas",
    "209": "Cama extra",
    "210": "Colchón",
    "215": "Servicio de recogida en el aeropuerto",
    "225": "Servicio de limpieza",
    "227": "Piscina",
    "231": "Limpieza semanal gratuita",
    "232": "Lavandería y tintorería",
    "233": "Tintorería",
    "234": "Lavandería",
    "235": "Desayuno",
    "237": "Sofá cama",
    "239": "Ducha",
    "245": "Lavabo",
    "248": "Espacio de almacenamiento",
    "249": "Salón",
    "250": "Mesa de comedor",
    "252": "Bañera",
    "253": "Jacuzzi",
    "257": "Dormitorio",
    "258": "Estufa / Cocina económica",
    "261": "Ventilador",
    "277": "Muebles antiguos",
    "281": "Posible acceso para sillas de ruedas",
    "294": "Gimnasio en el edificio para uso de los huéspedes",
    "295": "Aparcamiento en la calle",
    "296": "Aparcamiento subterráneo",
    "298": "Conserje en el edificio",
    "302": "Aparcamiento vigilado",
    "308": "Teléfono (solo llamadas entrantes)",
    "309": "Teléfono (llamadas entrantes y salientes)",
    "311": "Tocador",
    "312": "Máquina de fax",
    "314": "Internet (con ordenador incluido)",
    "315": "Bañera",
    "320": "Entrada separada",
    "321": "Baño separado",
    "322": "Puerta a la terraza",
    "323": "Cama individual",
    "324": "Cama tamaño king",
    "325": "Reproductor de DVD",
    "326": "Selección de CD",
    "327": "Selección de DVD",
    "328": "Suelo radiante",
    "330": "Mapas de la ciudad",
    "331": "Nevera totalmente abastecida",
    "332": "Folletos informativos",
    "334": "Comida y bebida GRATIS",
    "336": "Frutas GRATIS",
    "337": "Ramos de flores GRATIS",
    "338": "Leña GRATIS para la chimenea",
    "339": "Acceso a internet GRATIS",
    "341": "Sábanas finas de algodón egipcio",
    "342": "Selección de comida y bebida",
    "344": "Albornoz",
    "345": "Panel LCD",
    "346": "Jardín",
    "347": "Amplia selección de comida de lujo, bebidas, vinos, cafés y tés",
    "348": "Nevera totalmente abastecida con todo tipo de comida fresca y bebidas",
    "349": "Chimenea de leña",
    "351": "Toallas de baño grandes de rizo",
    "352": "Artículos de aseo \"Molton Brown\"",
    "353": "Plantas de orquídeas",
    "354": "Línea telefónica internacional GRATIS",
    "355": "En estancias semanales: servicio de limpieza que incluye lavandería / planchado personal",
    "359": "Piano",
    "360": "Secadora",
    "361": "Campana extractora",
    "362": "Cocina, salón y jardín compartidos con otros huéspedes",
    "363": "Sillón",
    "364": "Chimenea",
    "365": "Sauna",
    "368": "Internet inalámbrico gratuito",
    "371": "Cine en casa",
    "372": "Salón / Dormitorio",
    "373": "Cocina común",
    "374": "Alquiler de teléfonos móviles",
    "375": "Servicios de fax y fotocopias",
    "376": "Cafetera",
    "379": "TV por cable digital",
    "380": "Té y café de cortesía",
    "382": "Sillas auxiliares",
    "384": "Literas (individual arriba, doble abajo)",
    "385": "Cunas, tronas, colchón (bajo petición)",
    "388": "Desván / Loft",
    "389": "TV de plasma de pantalla plana",
    "390": "Máquina de espresso",
    "391": "Bañera de hidromasaje",
    "395": "Toallas",
    "396": "Dormitorio en nicho / alcoba",
    "397": "Mesita auxiliar",
    "404": "Club de salud",
    "408": "Parrilla / Barbacoa",
    "409": "Baño privado en suite",
    "412": "Vestidor",
    "413": "Máquina de hielo",
    "414": "Lavabo doble",
    "415": "Piscina de spa",
    "417": "Llamadas de larga distancia gratuitas",
    "418": "Sistema de videojuegos",
    "419": "Sistema de videojuegos con juegos",
    "420": "Uso gratuito de radios bidireccionales",
    "421": "Sala de juegos",
    "422": "Artículos de aseo iniciales",
    "426": "Teléfono (llamadas entrantes y locales salientes)",
    "428": "Sillón que se convierte en cama individual",
    "429": "Alquiler de ordenadores",
    "432": "Sillón cama",
    "433": "Internet inalámbrico de alta velocidad gratuito",
    "434": "Inodoro/bidé",
    "435": "Estufa de gas",
    "436": "Batidora / Licuadora",
    "437": "Placas calientes",
    "438": "Acceso a internet de alta velocidad",
    "439": "Comedor",
    "440": "Par de camas individuales",
    "444": "Litera",
    "445": "TV de gran pantalla",
    "446": "Jabón / Champú / Acondicionador de cortesía",
    "447": "Toallero calefactado",
    "448": "Limpieza semanal gratuita",
    "449": "Río",
    "450": "Calle",
    "451": "Patio interior",
    "452": "Plaza",
    "453": "Habitación anexa",
    "454": "Suelo de mármol",
    "455": "2 camas individuales en el salón",
    "456": "Sillas",
    "457": "Invernadero",
    "458": "Ducha de hidromasaje",
    "459": "Suelo de parqué",
    "460": "Sofá seccional / modular",
    "461": "Centro de negocios",
    "462": "Electrodomésticos de última generación",
    "463": "Encimeras de granito",
    "464": "Armarios a medida",
    "465": "Pista de tenis",
    "466": "Guardería",
    "467": "Gimnasio de la residencia",
    "468": "TV de pantalla plana LCD",
    "472": "Servicio de compras personal",
    "473": "Cuarto de estar / Guarida",
    "476": "Horizonte de la ciudad",
    "478": "Centro de la ciudad",
    "479": "Campo de golf",
    "480": "TV de pantalla panorámica",
    "481": "Suelo de madera",
    "482": "Maquinilla de afeitar eléctrica",
    "483": "Ventanas de madera",
    "484": "Libros guía",
    "485": "Cama tamaño queen",
    "490": "Ventiladores bajo petición",
    "491": "Plancha/Tabla de planchar bajo petición",
    "497": "Instalaciones para guardar equipaje",
    "499": "Percha",
    "500": "Estantería",
    "501": "Cama de día / Diván",
    "503": "Espejo",
    "504": "Aparcamiento privado",
    "505": "Guardarropa / Vestíbulo",
    "506": "Armarios",
    "507": "Mesa",
    "508": "Silla",
    "509": "Lámpara de lectura",
    "510": "Lago",
    "511": "Mar",
    "512": "Océano",
    "513": "Canal",
    "514": "Entresuelo",
    "515": "Cama abatible",
    "516": "Ducha en suite",
    "517": "Dormitorio/Salón con rincón de cocina",
    "589": "Ropa de cama",
    "590": "Plancha",
    "591": "Tabla de planchar",
    "592": "Teléfono",
    "593": "Ordenador",
    "594": "Vista al canal",
    "595": "Se admiten mascotas",
    "596": "Cuna gratuita en el apartamento",
    "597": "Cuna gratuita bajo petición",
    "598": "Conserjería",
    "599": "Lavadora secadora",
    "600": "Secadora",
    "601": "Caja fuerte",
    "602": "Almacén de esquí",
    "603": "Vista a la montaña",
    "604": "Vista al mar",
    "605": "Sala de fitness",
    "606": "Spa",
    "607": "Baño de vapor",
    "608": "Servicio de habitaciones",
    "609": "Vista a la pista de esquí",
    "611": "Bañera de hidromasaje (privada)",
    "612": "Bañera de hidromasaje (común)",
    "613": "Lavandería (privada)",
    "614": "Lavandería (común)",
    "615": "Minibar",
    "616": "Portero",
    "617": "Sala de desayunos",
    "618": "Sala de reuniones",
    "619": "Restaurante",
    "620": "Bar",
    "621": "Salón de belleza",
    "622": "Zona infantil",
    "623": "Acceso directo a pistas de esquí",
    "624": "Cama supletoria extraíble",
    "625": "Jardín (privado)",
    "626": "Jardín (común)",
    "627": "Recepción",
    "628": "Servicio de lavandería",
    "629": "Habitaciones contiguas",
    "630": "Adaptadores de enchufe",
    "631": "Mostrador de aerolínea",
    "632": "Plan de comidas - Americano",
    "633": "Cajero automático",
    "634": "Equipo audiovisual",
    "635": "Servicios de canguro / infantil",
    "636": "Barbería",
    "637": "En la bahía",
    "638": "Vista a la bahía",
    "639": "Plan de comidas - Alojamiento y desayuno",
    "640": "Dispositivo de escucha para bebés",
    "641": "Vista a la playa",
    "642": "Playa",
    "643": "Peluquería/Barbería",
    "644": "Botones / Maleteros",
    "645": "Alquiler de bicicletas",
    "646": "Pizarra",
    "647": "Billar / Mesas de pool",
    "648": "Paseos en bote",
    "649": "Boutiques",
    "650": "Bolos",
    "651": "Plan de comidas - Bermudas",
    "652": "Ascensor con braille",
    "653": "Bufé de desayuno",
    "654": "Teléfono en el baño",
    "655": "Cama con dosel / de estilo colonial",
    "656": "Mostrador de alquiler de coches",
    "657": "Casino",
    "658": "Habitación estilo castillo",
    "659": "Plan de comidas - Caribeño",
    "660": "Reproductor de CD",
    "661": "Ventilador de techo",
    "662": "Vista a la ciudad",
    "663": "Instalaciones para conferencias",
    "664": "Suite para conferencias",
    "665": "Desayuno continental",
    "666": "Cafetería",
    "667": "Cafetera en la habitación",
    "668": "Ordenador en la habitación",
    "669": "Mostrador de conserjería",
    "670": "Habitaciones comunicadas",
    "671": "Plan de comidas - Continental",
    "672": "Servicio de copias",
    "673": "Teléfono inalámbrico",
    "674": "Cunas disponibles",
    "675": "Coche de cortesía",
    "676": "Centro de la ciudad",
    "677": "Cambio de divisas",
    "678": "Puerto de datos disponible",
    "679": "Recepción 24 horas",
    "680": "Guía de restaurantes",
    "681": "Cena",
    "682": "Habitaciones/instalaciones para discapacitados",
    "683": "Discoteca",
    "684": "Médico a domicilio",
    "685": "Farmacia",
    "686": "Campo de prácticas de golf",
    "687": "Escritorio con lámpara",
    "688": "Cerraduras electrónicas",
    "689": "Ascensor",
    "690": "Servicio de correo electrónico",
    "691": "Entretenimiento en vivo",
    "692": "Plan de comidas - Europeo",
    "693": "Check-in exprés",
    "694": "Escritorio ejecutivo",
    "695": "Checkout exprés",
    "696": "Planta ejecutiva",
    "697": "Plan de comidas - Pensión completa",
    "698": "Desayuno inglés completo",
    "699": "Habitaciones para ejecutivas",
    "700": "Pesca",
    "701": "Floristería",
    "702": "Aparcamiento gratuito",
    "703": "Llamadas locales gratuitas",
    "704": "Transporte gratuito",
    "705": "Vista al jardín",
    "706": "Tienda de regalos",
    "707": "Alquiler de juegos",
    "708": "Golf",
    "709": "Vista al campo de golf",
    "710": "Paseos a caballo",
    "711": "Pista para correr",
    "712": "Residencia canina",
    "713": "Actividades para niños",
    "714": "Vista al lago",
    "715": "Lavandería autoservicio para huéspedes",
    "716": "Almuerzo",
    "717": "Plan de comidas - Media pensión",
    "718": "Masaje",
    "719": "Minigolf",
    "720": "Películas en la habitación",
    "721": "Instalaciones para reuniones",
    "722": "Suite de reuniones",
    "723": "Personal multilingüe",
    "724": "Guardería infantil",
    "725": "Habitaciones/instalaciones para no fumadores",
    "726": "Club nocturno",
    "727": "Periódico gratuito",
    "728": "Quiosco de prensa",
    "729": "Vista al océano",
    "730": "Proyector de transparencias",
    "731": "Parasailing",
    "732": "Vista al parque",
    "733": "No se admiten mascotas",
    "734": "Servicio telefónico",
    "735": "Zona de pícnic / Mesas",
    "736": "Parque infantil",
    "737": "Piscina climatizada",
    "738": "Piscina cubierta",
    "739": "Piscina infantil",
    "740": "Piscina al aire libre",
    "741": "Snackbar junto a la piscina",
    "742": "Proyector",
    "743": "Squash",
    "744": "Vista al río",
    "745": "Acceso con rampa a los edificios",
    "746": "Servicio de habitaciones 24 horas",
    "747": "Caja de seguridad",
    "748": "Navegación a vela",
    "749": "Buceo",
    "750": "Servicio de secretaría",
    "751": "Seguridad 24 horas",
    "752": "Centro comercial",
    "753": "Transporte gratuito al aeropuerto",
    "754": "Tiro al plato",
    "755": "Esquí",
    "756": "Esquí de fondo",
    "757": "Snorkel",
    "758": "Snowboard",
    "759": "Centro de fitness o spa",
    "760": "Baño de vapor",
    "761": "Télex",
    "762": "Tenis cubierto",
    "763": "Tenis",
    "764": "Tenis al aire libre",
    "765": "Mostrador de información turística",
    "766": "Servicio de traducción",
    "767": "Servicios de lavandería",
    "768": "Máquinas expendedoras",
    "769": "Habitaciones/Servicios VIP",
    "770": "Voleibol",
    "771": "Servicio de despertador",
    "772": "Servicios de boda",
    "773": "Windsurf",
    "774": "Esquí acuático",
    "775": "Barras de apoyo en el baño",
    "776": "Habitaciones climatizadas",
    "777": "Módem en la habitación",
    "778": "Cama plegable tipo Murphy",
    "779": "Camas supletorias",
    "780": "Albomoz",
    "781": "Detectores de humo",
    "782": "Solárium",
    "783": "Rociadores en las habitaciones",
    "784": "Mostrador de teatro",
    "785": "Control de temperatura",
    "786": "Prensa de pantalones",
    "788": "Base para iPod",
    "789": "Calefacción",
    "790": "Equipo de alta fidelidad",
    "791": "Tienda libre de impuestos",
    "792": "Internet inalámbrico",
    "793": "Aparcamiento",
    "794": "Aparcamiento al aire libre",
    "795": "Servicio de aparcacoches",
    "796": "Esterillas de rezo",
    "797": "Pistas de ráquetbol",
    "798": "Nevera",
    "799": "Se permite fumar",
    "800": "Chef a disposición",
    "801": "Vista a la marina",
    "802": "Se permite fumar",
    "803": "Aparcamiento gratuito en la calle",
    "804": "Aparcamiento de pago en la calle",
    "805": "Aparcamiento gratuito con garaje",
    "806": "Aparcamiento de pago con garaje",
    "807": "Internet por cable gratuito",
    "808": "Internet por cable de pago",
    "809": "Internet inalámbrico de pago",
    "810": "Cuna de pago bajo petición",
    "811": "Petanque",
    "812": "Consultar sobre fumadores",
    "813": "Consultar sobre mascotas",
    "814": "Consultar sobre accesibilidad",
    "815": "Piscina comunitaria",
    "816": "Piscina privada",
    "817": "Mesa de ping-pong",
    "818": "Reserva de desayuno posible",
    "819": "Limpieza de la casa opcional",
    "820": "Deportes - natación",
    "821": "Hospital local",
    "822": "Tiendas de comestibles locales",
    "823": "Frente al agua",
    "824": "Cerca del océano",
    "825": "Cocina compartida",
    "826": "Piscina compartida",
    "827": "Garaje",
    "828": "Apto para familias/niños",
    "829": "Espacio de trabajo con portátil",
    "830": "Exprimidor / Licuadora de jugos",
    "831": "Cámara de seguridad en la entrada",
    "832": "Reproductor de MP3",
    "833": "Cuna para bebé",
    "834": "Gimnasio",
    "835": "Pádel",
    "836": "Acceso en taxi",
    "837": "Acceso a la azotea",
    "838": "Trona para bebé",
    "839": "Cuna para bebé de pago",
    "840": "Trona bajo petición",
    "841": "Trona bajo petición",
    "842": "Mascotas de pago",
    "843": "Mascotas aceptadas bajo petición",
    "844": "Cochecito de paseo",
    "845": "Cubettería para bebé",
    "846": "Conexión a internet bajo petición",
    "847": "TV por cable bajo petición",
    "848": "Lavandería/tintorería bajo petición",
    "849": "Llamadas internacionales gratuitas",
    "850": "Chimenea",
    "851": "TV 3D",
    "852": "Smart TV",
    "853": "Coche gratuito",
    "854": "Bicicleta gratuita",
    "855": "Se acepta pago con tarjeta de crédito",
    "856": "No se permiten fiestas",
    "857": "No se admiten niños menores de 4 años",
    "858": "No se admiten niños menores de 12 años",
    "859": "No se admiten menores de 25 años",
    "860": "No se admiten menores de 30 años",
    "861": "No se admiten menores de 35 años",
    "862": "No se admiten menores de 18 años",
    "863": "No se aceptan reservas de más de 30 días",
    "864": "No se admiten grupos de menores de 18 años",
    "865": "No se admiten grupos de menores de 25 años",
    "866": "No se admiten grupos de menores de 30 años",
    "867": "No se admiten grupos de menores de 35 años",
    "868": "Solo familias",
    "869": "No se admiten menores de 40 años",
    "870": "No se admiten niños menores de 6 años",
    "871": "No se admiten grupos de menores de 50 años",
    "872": "No se admiten grupos del mismo sexo menores de 30 años",
    "873": "No se admiten grupos de menores de 45 años",
    "874": "No se admiten grupos del mismo sexo menores de 35 años",
    "875": "Llegadas en domingo",
    "876": "Solo familias o parejas",
    "877": "Trona para bebé de pago",
    "878": "Trona para bebé de pago",
    "879": "Adaptador USB WiFi",
    "880": "Agua embotellada",
    "881": "Ventilación central controlada",
    "882": "Adaptadores eléctricos disponibles",
    "883": "Habitaciones hipoalergénicas",
    "884": "TV con navegador de internet",
    "885": "Convertidores de corriente",
    "886": "Kit de costura",
    "887": "Impresora",
    "888": "Zapatillas",
    "889": "Sistema de sonido",
    "890": "Ventanas insonorizadas",
    "891": "Báscula",
    "892": "Selección de habitación a la llegada",
    "893": "Ventana",
    "894": "Veranda",
    "895": "Patio",
    "896": "Aire acondicionado en áreas comunes",
    "897": "Centro de deportes acuáticos",
    "898": "Servicio de mensajería",
    "899": "Guardería",
    "900": "Servicio de limpieza",
    "901": "Actividades recreativas",
    "902": "Buceo",
    "903": "Peluquería",
    "904": "Tiendas del hotel",
    "905": "Excursiones entre islas",
    "906": "Moto acuática",
    "907": "Niños comen gratis",
    "908": "Salida tardía disponible",
    "909": "Servicio de limusina / coche de ciudad disponible",
    "910": "Guardia de seguridad",
    "911": "Limpieza de calzado",
    "912": "Máquina de limpieza de calzado",
    "913": "Servicio de transporte",
    "914": "Apto para niños",
    "915": "Servicio de venta de entradas",
    "916": "Servicio de preparación de cama",
    "917": "Paraguas / Sombrilla",
    "918": "Amenidades de bienvenida",
    "919": "Vista al campo o rural",
    "920": "Vista interior",
    "921": "Vista panorámica",
    "922": "Vista a la piscina",
    "923": "Vista al pueblo",
    "924": "Vista al valle",
    "925": "Vista al pueblo/ciudad",
    "926": "Vista poco común",
    "927": "Vista al lago escocés",
    "928": "Piscina exterior climatizada",
    "929": "No se admiten bebés",
    "930": "Apto para familias",
    "931": "Coche necesario",
    "932": "Coche recomendado",
    "933": "Coche no necesario",
    "934": "Romántico",
    "935": "Lujo",
    "936": "Económico",
    "937": "Vista al agua",
    "938": "Tumbona de playa",
    "939": "Cama francesa",
    "940": "Papel higiénico",
    "941": "Jabón",
    "942": "No se admiten niños",
    "943": "Detector de monóxido de carbono",
    "944": "Piscina privada climatizada",
    "945": "Fútbol de mesa",
    "946": "Diana",
    "947": "Mesa de hockey de aire",
    "948": "Canasta de baloncesto",
    "949": "Valla de seguridad en la piscina",
    "950": "Calefactor para patio",
    "951": "Tumbonas",
    "952": "Iluminación exterior",
    "953": "Apto para personas mayores",
    "954": "Tranquilo",
    "955": "Extintor de incendios",
    "956": "Ducha de fácil acceso (sin barreras)",
    "957": "Cama triple litera",
    "958": "Minisúper en el lugar",
    "959": "Solo adultos",
    "960": "Cambio de toallas bajo petición",
    "961": "Mejora de habitación disponible sujeta a disponibilidad",
    "962": "Mejora de habitación garantizada",
    "963": "Mejora de habitación gratuita disponible",
    "964": "Crédito en el resort incluido",
    "965": "Regalo de bienvenida a la llegada",
    "966": "Productos de limpieza ecológicos",
    "967": "Reciclaje de aguas grises",
    "968": "Energía renovable - geotérmica",
    "969": "Energía renovable - solar",
    "970": "Energía renovable - eólica",
    "971": "Artículos esenciales (toallas, almohadas, ropa de cama, jabón, papel higiénico)",
    "972": "Perchas",
    "973": "Agua caliente",
    "974": "Lavadora",
    "976": "Libre de alérgenos",
    "977": "Toallas de playa",
    "978": "Productos de limpieza",
    "979": "Tapones para los oídos",
    "980": "Taquillas",
    "981": "Mosquitera",
    "984": "Cortina privada",
    "985": "Control de clima en la habitación",
    "986": "Guía de restaurantes",
    "987": "Sistema de calefacción / refrigeración controlado por el usuario",
    "988": "Armario separado",
    "989": "Sombrillas de playa",
    "990": "Cubos de basura",
    "991": "Estación de carga para vehículos eléctricos",
    "992": "Servicio de planchado",
    "993": "Cesta para mascotas",
    "994": "Recipientes para mascotas",
    "995": "Sin plásticos de un solo uso",
    "996": "Sin artículos de aseo de un solo uso",
    "997": "Elegibilidad para puntos de fidelidad del hotel",
    "998": "Frente a la playa",
    "999": "Jardín o patio trasero",
    "1000": "Casa de una sola planta",
    "1002": "Zona designada para fumadores",
    "1003": "Independiente / Aislado",
    "1004": "Zona de estar 'engawa'",
    "1005": "Hoguera / Foso de fuego",
    "1006": "Balcón amueblado",
    "1007": "Lanai amueblado",
    "1008": "Patio amueblado",
    "1009": "Jardín japonés",
    "1010": "Pared de plantas vivas",
    "1011": "Huerto de verduras",
    "1012": "Vista al golfo",
    "1013": "Vista al puerto",
    "1014": "Vista a la colina",
    "1015": "Vista a la laguna",
    "1016": "Lanai",
    "1017": "Vista a un punto emblemático",
    "1018": "Marina / Puerto deportivo",
    "1019": "Vistas múltiples",
    "1020": "Sin vista",
    "1021": "Baño al aire libre",
    "1022": "Zona de comedor al aire libre",
    "1023": "Chimenea exterior",
    "1024": "Muebles de exterior",
    "1025": "Bote",
    "1026": "Zona de entretenimiento al aire libre",
    "1027": "Equipo de deportes acuáticos",
    "1028": "Vista parcial al lago",
    "1029": "Vista parcial",
    "1030": "Porche",
    "1031": "Piso privado en bloque de pisos",
    "1032": "Vista a calle tranquila",
    "1033": "Vista al resort",
    "1034": "Semindependiente / Adosado",
    "1035": "Solárium / Terraza soleada",
    "1036": "Vista al desierto",
    "1037": "Vista parcial al océano",
    "1038": "Vista parcial al mar",
    "1039": "Vista al viñedo",
    "1040": "1 safari fotográfico por noche",
    "1041": "2 safaris fotográficos por noche",
    "1042": "Bingo",
    "1043": "Juegos de mesa / rompecabezas",
    "1044": "Libros",
    "1045": "Crédito para el casino",
    "1046": "Casino cercano",
    "1047": "Conciertos o actuaciones en vivo",
    "1048": "Clase de cocina",
    "1049": "Entradas para parques Disney",
    "1050": "Personal de animación",
    "1051": "Entretenimiento nocturno",
    "1052": "Clases de fitness",
    "1053": "Instalaciones de fitness",
    "1054": "Instalaciones de fitness cercanas",
    "1055": "Vestuarios de spa con fitness",
    "1056": "Pediluvio / Baño de pies",
    "1057": "Pases gratuitos para parque acuático",
    "1058": "Happy hour",
    "1059": "Aguas termales cercanas",
    "1060": "Aguas termales en el lugar",
    "1061": "Baño público cubierto sin aguas minerales",
    "1062": "Piscina infinity",
    "1063": "Bañera de hidromasaje",
    "1064": "Karaoke",
    "1065": "Juegos de azar recreativos",
    "1066": "Biblioteca",
    "1067": "Retransmisión de eventos deportivos en vivo",
    "1068": "Sillón de masaje",
    "1069": "Juego de partido",
    "1070": "Aguas termales minerales cubiertas",
    "1071": "Aguas termales minerales al aire libre",
    "1072": "Noches de cine",
    "1073": "Baño público al aire libre - sin aguas minerales",
    "1074": "Entrenador personal disponible",
    "1075": "Piscina de inmersión",
    "1076": "Bar en la piscina",
    "1077": "Cubierta para piscina",
    "1078": "Toallas de piscina",
    "1079": "Piscina con vistas",
    "1080": "Piscina elevada",
    "1081": "Cabañas junto a la piscina",
    "1083": "Piscina excavada en tierra",
    "1084": "Tumbonas de piscina",
    "1085": "Sombrillas de piscina",
    "1086": "Cascada en la piscina",
    "1087": "Zona de playa privada",
    "1088": "Pub crawls / Rutas de bares",
    "1089": "Baño público",
    "1090": "Piscina en la azotea",
    "1091": "Material de arte",
    "1092": "Instrumentos musicales",
    "1093": "Aguas termales minerales privadas - cubiertas",
    "1094": "Aguas termales minerales privadas - al aire libre",
    "1095": "Piscina de agua salada",
    "1096": "Zona poco profunda de la piscina",
    "1097": "Juego de tragamonedas",
    "1098": "Espectáculo de comedia",
    "1099": "Bar con acceso directo desde la piscina",
    "1100": "Juguetes para piscina",
    "1101": "Telescopio",
    "1102": "Galerías de arte temporales",
    "1103": "Cenas temáticas",
    "1104": "Tour o clase sobre cultura local",
    "1105": "Trampolín",
    "1106": "Visitas guiadas a pie",
    "1107": "Tobogán acuático",
    "1108": "Hidromasaje / Jacuzzi",
    "1109": "Bodega / Viñedo",
    "1110": "Visitas privadas a la bodega en el lugar",
    "1111": "Visitas públicas a la bodega en el lugar",
    "1112": "Eventos de lanzamiento de vino en el lugar",
    "1113": "Sala de cata en la bodega en el lugar",
    "1114": "Visitas a bodegas cercanas",
    "1115": "Viñedo en el lugar",
    "1116": "Clases de yoga",
    "1117": "Crédito para golf",
    "1118": "Compras",
    "1119": "Pista de hielo cercana",
    "1120": "Pista de hielo en el lugar",
    "1121": "Aeróbic",
    "1122": "Tiro con arco en el lugar",
    "1123": "Parques temáticos",
    "1124": "Equipo de bádminton",
    "1125": "Acceso directo a playa privada cercana",
    "1126": "Acceso directo a playa pública cercana",
    "1127": "Cabañas de playa",
    "1128": "Voleibol de playa en el lugar",
    "1129": "Yoga en la playa en el lugar",
    "1130": "Tours en bicicleta",
    "1131": "Ciclismo en carretera cercano",
    "1132": "Observación de aves cercana",
    "1133": "Observación de aves en el lugar",
    "1134": "Canoa en el lugar",
    "1135": "Bote en el lugar",
    "1136": "Bote inflable en el lugar",
    "1137": "Kayak en el lugar",
    "1138": "Bote a pedales en el lugar",
    "1139": "Velero en el lugar",
    "1140": "Paseos en bote cercanos",
    "1141": "Paseos en bote en el lugar",
    "1142": "Exploración de cuevas cercana",
    "1143": "Exploración de cuevas en el lugar",
    "1144": "Ciclismo",
    "1145": "Ecotours cercanos",
    "1146": "Ecotours en el lugar",
    "1147": "Clases de agricultura",
    "1148": "Mesa para limpiar pescado",
    "1149": "Safari fotográfico cercano",
    "1150": "Safari fotográfico en el lugar",
    "1151": "Caminata de caza o avistamiento de fauna cercana",
    "1152": "Caminata de caza o avistamiento de fauna en el lugar",
    "1153": "Avistamiento de fauna cercano",
    "1154": "Avistamiento de fauna en el lugar",
    "1155": "Caddie de golf",
    "1156": "Carrito de golf",
    "1157": "Club de golf / Casa club",
    "1158": "Equipo de golf",
    "1159": "Campo de golf sin campo de prácticas",
    "1160": "Tienda profesional de golf",
    "1161": "Tours en helicóptero o avioneta en el lugar",
    "1162": "Senderismo",
    "1163": "Senderismo y ciclismo cercanos",
    "1164": "Senderismo y ciclismo en el lugar",
    "1165": "Caza cercana",
    "1166": "Caza en el lugar",
    "1167": "Kayak cercano",
    "1168": "Kayak en el lugar",
    "1169": "Río lento",
    "1170": "Bote a motor cercano",
    "1171": "Bote a motor en el lugar",
    "1172": "Escalada de montaña cercana",
    "1173": "Moto de agua cercana",
    "1174": "Moto de agua en el lugar",
    "1175": "Rafting cercano",
    "1176": "Rafting en el lugar",
    "1177": "Circuito de cuerdas para team building en el lugar",
    "1178": "Remo o piragüismo en el lugar",
    "1179": "Safari cercano",
    "1180": "Safari en el lugar",
    "1181": "Buceo cercano",
    "1182": "Paracaidismo cercano",
    "1183": "Paracaidismo en el lugar",
    "1184": "Snorkel cercano",
    "1185": "Surf o boogieboarding cercano",
    "1186": "Surf o boogieboarding en el lugar",
    "1187": "Equipo de tenis",
    "1188": "Clases de tenis en el lugar",
    "1189": "Camino al agua",
    "1191": "Parque acuático",
    "1192": "Esquí acuático cercano",
    "1193": "Tubing acuático cercano",
    "1194": "Windsurf cercano",
    "1195": "Tirolina cercana",
    "1196": "Tirolina en el lugar",
    "1197": "Tipo de arena de playa: arena",
    "1198": "Tipo de arena de playa: arena negra",
    "1199": "Tipo de arena de playa: arena blanca",
    "1201": "Inodoro a altura accesible",
    "1202": "Acceso sin escalones al baño",
    "1203": "Puerta ancha de baño",
    "1204": "Acceso sin escalones al dormitorio",
    "1205": "Puerta ancha de dormitorio",
    "1206": "Grúa de techo",
    "1207": "Acceso sin escalones a espacios comunes",
    "1208": "Puerta ancha de espacios comunes",
    "1209": "Plaza de aparcamiento para discapacitados",
    "1210": "Cama eléctrica articulada",
    "1211": "Botiquín de primeros auxilios",
    "1212": "Cabezal de ducha de mano",
    "1213": "Acceso sin escalones al hogar",
    "1214": "Puerta ancha de entrada al hogar",
    "1215": "Cerradura en la puerta del dormitorio",
    "1216": "Grúa móvil",
    "1217": "Camino a la entrada iluminado por la noche",
    "1218": "Elevador de piscina",
    "1219": "Entrada privada",
    "1220": "Ducha abierta (sin bordillo)",
    "1221": "Silla de ducha",
    "1222": "Bañera con asiento de ducha",
    "1223": "Amplio espacio alrededor de la cama",
    "1224": "Amplio espacio alrededor de ducha e inodoro",
    "1225": "Amplio espacio en pasillos",
    "1226": "Baño accesible",
    "1227": "Aparcamiento accesible",
    "1228": "Camino de acceso accesible",
    "1229": "Bañera adaptada",
    "1230": "Guía auditiva",
    "1231": "Cuerda de emergencia en el baño",
    "1232": "Barandillas para cama",
    "1233": "Cierres de seguridad en armarios",
    "1234": "Protecciones de esquinas",
    "1235": "Acceso con tarjeta electrónica",
    "1237": "Toda la propiedad en planta baja",
    "1238": "Equipo para personas sordas",
    "1239": "Caja fuerte para portátil",
    "1240": "Lavabo bajo",
    "1241": "Contacto de emergencia médica",
    "1242": "Acceso con llaves metálicas",
    "1243": "Contacto de emergencia policial",
    "1244": "Puerta de seguridad en piscina",
    "1245": "Caja fuerte con capacidad para portátil",
    "1246": "Sistema de seguridad en la habitación",
    "1248": "Planta superior accesible solo por escaleras",
    "1249": "Ayudas visuales: braille",
    "1250": "Ayudas visuales: señales táctiles",
    "1251": "Protectores de ventanas",
    "1252": "Seguridad: advertencia de balcón",
    "1253": "Seguridad: propiedad totalmente cercada",
    "1254": "Capilla o santuario",
    "1255": "Habitaciones familiares",
    "1256": "Suite nupcial",
    "1257": "Habitaciones insonorizadas",
    "1258": "2 baños",
    "1259": "Baño privado en suite",
    "1260": "Baño privado",
    "1261": "Baño compartido",
    "1262": "Cocina completa",
    "1263": "Vestidor",
    "1264": "Habitaciones comunicadas disponibles",
    "1265": "Escritorio grande",
    "1266": "Zona de estar",
    "1267": "Escritorio con toma de corriente",
    "1268": "Armarios en la habitación",
    "1269": "Silla con escritorio",
    "1270": "Asientos en el comedor",
    "1271": "Múltiples armarios",
    "1272": "Área de asientos",
    "1273": "Suelo alfombrado",
    "1274": "Zona de comedor",
    "1276": "Perchero / Barra para ropa",
    "1277": "Decoración de la habitación",
    "1278": "Limpieza antes de la salida",
    "1282": "Limpieza diaria",
    "1283": "Limpieza una vez por estancia",
    "1284": "Limpieza solo los fines de semana",
    "1285": "Limpieza solo entre semana",
    "1286": "Servicio de habitaciones limitado",
    "1287": "Servicio de habitaciones genérico",
    "1288": "Bufé 2x1",
    "1289": "Todas las comidas",
    "1290": "Todo incluido",
    "1291": "Bar de playa",
    "1292": "Desayuno para 1",
    "1293": "Desayuno para 2",
    "1294": "Desayuno en la habitación",
    "1295": "Galletas de chocolate",
    "1296": "Cafetera / Tetera",
    "1297": "Recepción de vino de cortesía",
    "1298": "Desayuno continental para 2",
    "1299": "Cena para parejas",
    "1300": "Bebidas y aperitivos",
    "1301": "Crédito para comida y bebida",
    "1302": "Desayuno gratuito para 1 adulto",
    "1303": "Cena gratuita para 1 adulto",
    "1304": "Bebida de bienvenida gratuita",
    "1305": "Pensión completa",
    "1306": "Supermercado",
    "1307": "Media pensión",
    "1308": "Mini nevera",
    "1309": "Cafetería en el lugar",
    "1310": "Almuerzos para llevar",
    "1311": "Nevera con máquina de hielo",
    "1312": "Solo servicio de comedor en la habitación",
    "1313": "Snack bar",
    "1314": "Menús para dietas especiales bajo petición",
    "1315": "Servicio de té",
    "1319": "Copas de vino",
    "1320": "Vino y champán",
    "1321": "Bañera para bebé",
    "1322": "Cambiador",
    "1323": "Libros y juguetes para niños",
    "1324": "Vajilla infantil",
    "1325": "Protectores de chimenea",
    "1326": "Protectores de enchufes",
    "1327": "Cortinas opacas",
    "1328": "Puertas de seguridad para escaleras",
    "1329": "Protectores de esquinas de mesa",
    "1330": "Puertas de seguridad para bebés",
    "1331": "Juegos de mesa / rompecabezas",
    "1332": "Biblioteca infantil de libros, DVD y música",
    "1333": "Canales de televisión infantiles",
    "1334": "Juegos infantiles",
    "1335": "Juguetes de entretenimiento",
    "1336": "Zona de juegos cubierta",
    "1337": "Juguetes para bebés y niños pequeños",
    "1338": "Comidas para niños",
    "1339": "Equipo de juego exterior para niños",
    "1340": "Vajilla infantil",
    "1341": "Cuidado de niños",
    "1342": "Zapatillas de niño",
    "1344": "Cama extra grande doble",
    "1345": "Camas extra largas de 2 metros",
    "1346": "Colchón futón",
    "1347": "Cama doble grande",
    "1348": "Edredón nórdico de plumas",
    "1349": "Cama hipoalergénica disponible",
    "1350": "Cama a altura accesible",
    "1352": "Elementos básicos de cocina",
    "1353": "Suministros de cocina",
    "1354": "Zona de cocina y comedor",
    "1355": "Utensilios de cocina",
    "1356": "Microondas compartido (no en la habitación)",
    "1357": "Nevera con microondas",
    "1358": "Molino de café",
    "1359": "Plancha / Griddle",
    "1360": "Olla para langosta",
    "1361": "Batidora / Mezcladora",
    "1362": "Especias",
    "1363": "Fogones",
    "1364": "Gofrera",
    "1366": "Videoteca de entretenimiento",
    "1367": "Películas / videos gratis",
    "1368": "Películas de pago por visión en TV",
    "1369": "Lista de canales de películas disponibles",
    "1370": "CNN disponible",
    "1371": "Reproductor de Blu-ray",
    "1372": "Canales de pago por visión",
    "1373": "Películas de estreno",
    "1374": "Canales de TV premium",
    "1375": "Servicio de streaming como Netflix",
    "1376": "Vídeo bajo demanda",
    "1377": "Incluye una película gratuita en la habitación",
    "1378": "Portátil",
    "1379": "Teléfono de texto TDD",
    "1380": "Teléfono multilínea",
    "1381": "Teléfono para personas con discapacidad auditiva",
    "1382": "Teléfono de dos líneas",
    "1383": "Radio por satélite",
    "1384": "Teléfonos móviles / celulares disponibles",
    "1385": "iPad",
    "1386": "Consola de juegos Xbox 360",
    "1387": "Consola de juegos PlayStation 2",
    "1388": "Consola de juegos PlayStation 3",
    "1389": "Consola de juegos Nintendo Wii",
    "1390": "Consola de juegos Xbox One",
    "1391": "Consola de juegos Wii U",
    "1392": "Consola de juegos PlayStation 4",
    "1393": "Smartphone disponible",
    "1394": "Cargador para vehículo eléctrico",
    "1395": "Asistencia para tours",
    "1396": "Sábanas italianas Frette",
    "1397": "Colchón premium",
    "1398": "Acceso a sala VIP de negocios",
    "1399": "Llamadas gratuitas disponibles",
    "1400": "Servicio de champán",
    "1401": "Tiendas de lujo",
    "1402": "Acceso gratuito al centro de fitness",
    "1403": "Acceso gratuito al centro de negocios",
    "1404": "Acceso VIP a discotecas",
    "1406": "Ropa de baño",
    "1407": "Bañera con chorros de hidromasaje",
    "1408": "Solo bañera",
    "1409": "Bañera estilo grecorromano",
    "1410": "Solo ducha",
    "1411": "Bañera y jacuzzi separados",
    "1412": "Bañera de gran tamaño",
    "1413": "Bañera y ducha separadas",
    "1414": "Zona de inodoro separada",
    "1415": "Baño de spa",
    "1417": "Aseo de cortesía",
    "1418": "Aseo adicional",
    "1419": "Baño adicional",
    "1420": "Cepillo de dientes",
    "1421": "Gorro de ducha",
    "1422": "Baño compartido con lavabo",
    "1424": "Baño exterior parcialmente abierto",
    "1425": "Albomoz de niño",
    "1426": "Bidé electrónico",
    "1427": "Artículos de aseo de diseñador",
    "1428": "Sandalias Geta",
    "1429": "Bañera de spa privada",
    "1430": "Bañera de inmersión profunda",
    "1431": "Bañera con agua de manantial en la habitación",
    "1432": "Bañera para bebé con cabezal de ducha tipo lluvia",
    "1433": "Toallas de papel",
    "1434": "Secador de pelo bajo petición",
    "1435": "Detergente para lavadora",
    "1436": "Ropa de cama",
    "1437": "Almohadas y mantas adicionales",
    "1438": "Mantas eléctricas",
    "1439": "Pijamas",
    "1440": "Yukata",
    "1441": "Enchufe cerca de la cama",
    "1442": "Almohadas de plumas",
    "1443": "Almohadas sin plumas",
    "1444": "Almohadas hipoalergénicas",
    "1445": "Menú de almohadas",
    "1446": "Privilegios opcionales de telesilla",
    "1447": "Snowboard en el lugar",
    "1448": "Trineo cercano",
    "1449": "Trineo en el lugar",
    "1450": "Tubing de nieve cercano",
    "1451": "Tubing de nieve en el lugar",
    "1452": "Motonieve cercana",
    "1453": "Motonieve en el lugar",
    "1454": "Raquetas de nieve cercanas",
    "1455": "Raquetas de nieve en el lugar",
    "1456": "Zona de esquí cercana",
    "1457": "Teleféricos cercanos",
    "1458": "Pistas de esquí cercanas",
    "1459": "Clases de esquí cercanas",
    "1460": "Clases de esquí en el lugar",
    "1461": "Privilegios de telesilla",
    "1462": "Pases de esquí",
    "1463": "Alquiler de esquís cercano",
    "1464": "Alquiler de esquís en el lugar",
    "1465": "Equipo de deportes de nieve",
    "1466": "Descensos cercanos",
    "1467": "Descensos en el lugar",
    "1468": "Escuela de esquí",
    "1469": "Alquiler de equipo de esquí en el lugar",
    "1470": "Vendedor de pases de esquí",
    "1471": "Transporte a pistas de esquí",
    "1472": "Acceso directo a pistas de esquí",
    "1473": "Alquiler gratuito de forfait",
    "1475": "Transporte a pistas de esquí cercano",
    "1476": "Piscina comunal de spa",
    "1477": "Bañera de hidromasaje de spa",
    "1478": "Piscina privada de spa",
    "1479": "Aromaterapia",
    "1480": "Ayurvédico",
    "1481": "Exfoliaciones corporales",
    "1483": "Envolturas corporales",
    "1485": "Hidroterapia",
    "1486": "Habitaciones de spa para parejas",
    "1487": "Zona de tratamiento al aire libre",
    "1488": "Talasoterapia",
    "1489": "Baño turco",
    "1490": "Envoltura de desintoxicación",
    "1491": "Reflexología",
    "1492": "Aguas termales",
    "1493": "Sauna en el spa",
    "1494": "Baño de barro en el spa",
    "1495": "Bañera de hidromasaje en el spa",
    "1496": "Baño de vapor en el spa",
    "1497": "Manicura y pedicura",
    "1498": "Pilates en el lugar",
    "1499": "Masaje - se requiere reserva anticipada",
    "1500": "Masaje en la playa",
    "1501": "Masaje de tejido profundo",
    "1502": "Masaje con piedras calientes",
    "1503": "Masaje prenatal",
    "1504": "Masaje deportivo",
    "1505": "Masaje sueco",
    "1506": "Masaje tailandés",
    "1507": "Instalaciones de spa",
    "1508": "Zona de relax del spa",
    "1509": "Paquetes de bienestar en el spa",
    "1510": "Masaje de espalda",
    "1511": "Masaje de cuello",
    "1512": "Masaje de pies",
    "1513": "Masaje en pareja",
    "1514": "Masaje de cabeza",
    "1515": "Masaje de manos",
    "1516": "Masaje corporal completo",
    "1517": "Peluquero / Esteticista",
    "1518": "Tratamientos faciales",
    "1519": "Servicios de depilación",
    "1520": "Servicios de maquillaje",
    "1521": "Tratamientos capilares",
    "1522": "Manicura",
    "1523": "Pedicura",
    "1524": "Corte de pelo",
    "1525": "Tinte de pelo",
    "1526": "Peinado",
    "1527": "Tratamientos corporales",
    "1528": "Exfoliación corporal",
    "1529": "Fototerapia",
    "1530": "Crédito para spa",
    "1538": "Alojamiento otros servicios coche disponible",
    "1539": "Estación de carga para coches eléctricos",
    "1540": "Alquiler de scooters o ciclomotores cercano",
    "1541": "Alquiler de scooters o ciclomotores en el lugar",
    "1542": "Servicio de transporte al aeropuerto con recargo",
    "1543": "Billetes de transporte público",
    "1544": "Check-in y check-out privados",
    "1545": "Traslado gratuito de regreso al aeropuerto",
    "1546": "Aparcamiento con plazas limitadas",
    "1547": "Tour en Segway cercano",
    "1548": "Tour en Segway en el lugar",
    "1549": "Bajada en transporte al aeropuerto gratuita",
    "1550": "Bajada en transporte al aeropuerto con recargo",
    "1551": "Recogida en transporte del aeropuerto gratuita",
    "1552": "Recogida en transporte del aeropuerto con recargo",
    "1553": "Transporte de ida y vuelta al aeropuerto gratuito",
    "1554": "Transporte de ida y vuelta al aeropuerto con recargo",
    "1555": "Servicio de transporte al aeropuerto genérico",
    "1556": "Servicio de transporte al aeropuerto disponible 24 horas",
    "1557": "Sin servicio de transporte al aeropuerto",
    "1558": "Transporte al aeropuerto - horario limitado",
    "1559": "Transporte al aeropuerto - disponible bajo petición",
    "1560": "Tarifa de transporte al aeropuerto para adultos disponible en horarios programados",
    "1561": "Tarifa de transporte al aeropuerto para adultos contactar con el establecimiento antes de la llegada",
    "1562": "Tarifa de transporte al aeropuerto para adultos importe de la tarifa",
    "1563": "Transporte en la zona gratuito",
    "1564": "Transporte en la zona con recargo por distancia",
    "1565": "Transporte en la zona genérico",
    "1566": "Transporte a la playa gratuito",
    "1567": "Transporte a la playa con recargo",
    "1568": "Transporte al centro comercial gratuito",
    "1569": "Transporte al centro comercial con recargo",
    "1570": "Transporte al casino gratuito",
    "1571": "Transporte al casino con recargo",
    "1572": "Transporte al parque temático gratuito",
    "1573": "Transporte al parque temático con recargo",
    "1574": "Transporte a la terminal de cruceros gratuito",
    "1575": "Transporte a la terminal de cruceros con recargo",
    "1576": "Transporte a la terminal de ferry con recargo",
    "1577": "Transporte a la terminal de ferry contactar con el establecimiento antes de la llegada",
    "1578": "Transporte a la terminal de ferry gratuito",
    "1579": "Servicio de recogida en estación de tren con recargo",
    "1580": "Servicio de recogida en estación de tren contactar con el establecimiento antes de la llegada",
    "1581": "Servicio de recogida en estación de tren gratuito",
    "1582": "Horario de transporte a la estación con recargo",
    "1583": "Horario de transporte a la estación disponible 24 horas",
    "1584": "Horario de transporte a la estación disponible en horarios programados",
    "1585": "Horario de transporte a la estación disponible con horario limitado",
    "1586": "Horario de transporte a la estación disponible bajo petición",
    "1587": "Debe contactar con el establecimiento para recogida/descenso gratuito",
    "1588": "Debe contactar con el establecimiento para recogida/descenso con recargo",
    "1589": "Debe contactar con el establecimiento para recogida a la llegada",
    "1590": "Debe contactar con el establecimiento para recogida 24 horas antes de la llegada",
    "1592": "Debe contactar con el establecimiento para recogida 48 horas antes de la llegada",
    "1593": "Debe contactar con el establecimiento para recogida 72 horas antes de la llegada",
    "1594": "Comedor snack bar o delicatessen",
    "1595": "Menú infantil",
    "1596": "Cocina afgana",
    "1597": "Cocina africana",
    "1598": "Cocina americana",
    "1599": "Cocina argentina",
    "1600": "Cocina asiática",
    "1601": "Cocina barbacoa",
    "1602": "Cocina vasca",
    "1603": "Cocina belga",
    "1604": "Cocina brasileña",
    "1605": "Cocina británica",
    "1606": "Cocina birmana",
    "1607": "Cocina cajún o criolla",
    "1608": "Cocina californiana",
    "1609": "Cocina camboyana",
    "1610": "Cocina caribeña",
    "1611": "Cocina china",
    "1612": "Cocina cubana",
    "1613": "Cocina dim sum",
    "1614": "Cocina de Europa del Este",
    "1615": "Cocina eritrea",
    "1616": "Cocina etíope",
    "1617": "Cocina filipina",
    "1618": "Cocina de pescado y patatas fritas",
    "1619": "Cocina fondue",
    "1620": "Cocina francesa",
    "1621": "Cocina fusión",
    "1622": "Cocina alemana",
    "1623": "Cocina griega",
    "1624": "Cocina halal",
    "1625": "Cocina hawaiana",
    "1626": "Cocina del Himalaya",
    "1627": "Cocina húngara",
    "1628": "Cocina indfivesian",
    "1629": "Cocina india",
    "1630": "Cocina internacional",
    "1631": "Cocina irlandesa",
    "1632": "Cocina italiana",
    "1633": "Cocina japonesa",
    "1634": "Cocina coreana",
    "1635": "Cocina kosher",
    "1636": "Cocina laosiana",
    "1637": "Cocina viva o cruda",
    "1638": "Cocina local",
    "1639": "Cocina local e internacional",
    "1640": "Cocina malasia",
    "1641": "Cocina mediterránea",
    "1642": "Cocina mexicana",
    "1643": "Cocina de Oriente Medio",
    "1644": "Cocina moderna europea",
    "1645": "Cocina mongola",
    "1646": "Cocina marroquí",
    "1647": "Cocina pakistaní",
    "1648": "Cocina panasiática",
    "1649": "Cocina persa / iraní",
    "1650": "Cocina peruana",
    "1651": "Cocina pizza",
    "1652": "Cocina polaca",
    "1653": "Cocina portuguesa",
    "1654": "Cocina regional",
    "1655": "Cocina rusa",
    "1656": "Cocina escandinava",
    "1657": "Cocina de mariscos",
    "1658": "Cocina singapurense",
    "1659": "Cocina soul food",
    "1660": "Cocina sureña",
    "1661": "Cocina española",
    "1662": "Cocina sushi",
    "1663": "Cocina taiwanesa",
    "1664": "Cocina tex-mex",
    "1665": "Cocina tailandesa",
    "1666": "Cocina turca",
    "1667": "Cocina ucraniana",
    "1668": "Cocina vegana",
    "1669": "Cocina vegetariana",
    "1670": "Cocina vietnamita",
    "1671": "Tiene bar",
    "1672": "Ubicación al aire libre",
    "1673": "Ubicación frente a la playa",
    "1674": "Ubicación con vistas al jardín",
    "1675": "Ubicación con vistas al golf",
    "1676": "Ubicación con vistas al océano",
    "1677": "Ubicación con vistas a la piscina",
    "1678": "Ubicación junto a la piscina",
    "1680": "Brunch",
    "1683": "Comida ligera",
    "1685": "Se requiere reserva",
    "1686": "Bistró",
    "1687": "Brasserie",
    "1688": "Bufé",
    "1689": "Cafetería",
    "1691": "Tienda de delicatessen",
    "1692": "Comedor / Diner",
    "1693": "Restaurante familiar",
    "1694": "Alta cocina",
    "1695": "Pub",
    "1697": "Mariscos",
    "1698": "Steakhouse",
    "1699": "Sushi bar",
    "1700": "Tapas",
    "1701": "Temático",
    "1702": "Tema de propiedad: deportes de aventura",
    "1703": "Tema de propiedad: playa",
    "1704": "Tema de propiedad: negocios",
    "1705": "Tema de propiedad: casino",
    "1706": "Tema de propiedad: familiar",
    "1707": "Tema de propiedad: golf",
    "1708": "Tema de propiedad: aguas termales",
    "1709": "Tema de propiedad: esquí",
    "1710": "Tema de propiedad: spa",
    "1711": "Tema de propiedad: romántico",
    "1712": "Tema de propiedad: bodega",
    "1713": "Tema de propiedad: ciudad",
    "1714": "Tema de propiedad: naturaleza",
    "1715": "Tema de propiedad: compras",
    "1716": "Diseño de propiedad: barroco",
    "1717": "Diseño de propiedad: bellas artes",
    "1718": "Diseño de propiedad: belle époque",
    "1719": "Diseño de propiedad: colonial",
    "1720": "Diseño de propiedad: art déco",
    "1721": "Diseño de propiedad: eduardiano",
    "1722": "Diseño de propiedad: georgiano",
    "1723": "Diseño de propiedad: mediterráneo",
    "1724": "Diseño de propiedad: tradicional",
    "1725": "Diseño de propiedad: Tudor",
    "1726": "Diseño de propiedad: toscano",
    "1727": "Diseño de propiedad: victoriano",
    "1728": "Aparcamiento requiere reserva",
    "1729": "Cobertura de internet en áreas públicas",
    "1730": "Cobertura de internet en todas las habitaciones",
    "1731": "Cobertura de internet en algunas habitaciones",
    "1732": "Cobertura de internet en el centro de negocios",
    "1733": "Se permiten fiestas",
    "1734": "Vista al patio interior",
    "1735": "No se permite fumar",
    "1736": "Apto para bebés",
    "1741": "Se requiere identificación del huésped al hacer el check-in",
    "1742": "No se permiten huéspedes con tatuajes",
    "1743": "Solo zona peatonal",
    "1744": "Acceso por camino sin pavimentar",
    "1745": "Zona residencial",
    "1746": "Zona concurrida",
    "1747": "Se requiere identificación del huésped",
    "1748": "No se permiten tatuajes",
    "1749": "Zona peatonal",
    "1750": "Acceso por camino sin pavimentar",
    "1751": "Zona residencial",
    "1752": "Zona concurrida",
    "1753": "Prácticas de limpieza mejoradas",
    "1754": "Limpieza realizada por empresas de limpieza profesionales",
    "1755": "Uso de desinfectantes para la limpieza",
    "1756": "Uso de productos químicos de limpieza eficaces contra el Coronavirus",
    "1757": "Distanciamiento social siguiendo las pautas de las autoridades locales",
    "1758": "Proceso para controlar la salud de los huéspedes",
    "1759": "Mascarillas disponibles",
    "1760": "Gel hidroalcohólico disponible",
    "1761": "Pantallas o barreras físicas entre el personal y los huéspedes en áreas designadas",
    "1762": "Check-in y check-out sin contacto disponible.",
    "1763": "Check-in sin contacto disponible",
    "1764": "Check-out sin contacto disponible",
    "1765": "El personal sigue todos los protocolos de seguridad de las autoridades locales",
    "1766": "La ropa de cama, toallas y ropa se lavan según las pautas de las autoridades locales",
    "1767": "Ropa de cama y toallas lavadas al menos a 60°C/140°F",
    "1768": "Platos, cubettería, vasos y otros utensilios de mesa desinfectados",
    "1769": "Superficies de alto contacto desinfectadas",
    "1770": "Alojamiento de los huéspedes sellado después de la limpieza",
    "1771": "Se puede evitar la limpieza del alojamiento de los huéspedes a petición",
    "1772": "El personal usa equipo de protección personal",
    "1773": "Controles de temperatura al personal",
    "1774": "La propiedad está vacía durante al menos 24 horas entre reservas.",
    "1775": "La propiedad está vacía durante al menos 48 horas entre reservas.",
    "1776": "La propiedad está vacía durante al menos 72 horas entre reservas.",
    "1777": "Se requiere documentación adicional relacionada con COVID-19",
    "1778": "No se admiten huéspedes de ciertos países",
    "1779": "Guantes disponibles para los huéspedes",
    "1780": "Se retiraron artículos de papelería compartidos (menús impresos, bolígrafos, papel)",
    "1781": "Botiquín de primeros auxilios disponible",
    "1782": "Pago sin efectivo disponible",
    "1783": "Propiedad disponible solo para viajeros esenciales de COVID-19",
    "1784": "Horario de servicio reducido",
    "1785": "Spa y gimnasio no disponibles",
    "1786": "Servicios en el lugar reducidos",
    "1787": "Servicio de transporte suspendido",
    "1788": "Distanciamiento social en las áreas de comedor",
    "1789": "Opciones de comida en la habitación disponibles",
    "1790": "Servicios de comida reducidos",
    "1791": "Comida para el desayuno envuelta individualmente",
    "1792": "Comida para el almuerzo envuelta individualmente",
    "1793": "Comida para la cena envuelta individualmente",
    "1794": "Comida envuelta individualmente en el servicio de habitaciones",
    "1795": "Aplicación móvil para servicio de habitaciones",
    "1796": "Se sigue el protocolo de desinfección Singapore SG Clean",
    "1797": "Se sigue el protocolo de desinfección Malaysia Safe & Clean",
    "1798": "Se sigue el protocolo de desinfección South Korea CESCO",
    "1799": "Se sigue el protocolo de desinfección Thailand Safety and Health Administration",
    "1801": "Se sigue el protocolo de desinfección Portugal Clean & Safe",
    "1802": "Se sigue el protocolo de desinfección del Ministerio de Industria, Comercio y Turismo de España",
    "1803": "Se sigue el protocolo de desinfección de la Confederación Española de Hoteles y Alojamientos Turísticos de España",
    "1804": "Se sigue el protocolo de desinfección National Protocol Accoglienza Sicura (Safe Hospitality) de Italy Federalberghi",
    "1805": "Se sigue el protocolo de desinfección Brazil Protected Tourist",
    "1807": "La propiedad sigue las prácticas de desinfección del Protocolo Sanitario (UNPLV - Francia)",
    "1809": "La propiedad sigue las prácticas de desinfección de SafeStay (AHLA - EE. UU.)",
    "1810": "La propiedad sigue la guía para la reapertura de alquileres vacacionales (DTV y DFV - Alemania)",
    "1811": "La propiedad sigue las prácticas de desinfección de la Asociación Europea de Viviendas Vacacionales (EHHA - Europa)",
    "1812": "La propiedad sigue las prácticas de desinfección de Intertek Cristal (experto externo - Global)",
    "1813": "La propiedad sigue las prácticas de desinfección de Safe Travels (WTTC - Global)",
    "1814": "La propiedad sigue las prácticas de desinfección de la Asociación de Turismo de Croacia (HUT - Croacia)",
    "1815": "La propiedad sigue las prácticas de desinfección de SafeHome (VRMA y VRHP)",
    "1817": "Check-in presencial",
    "1818": "Check-in con cajas de seguridad y cajas fuertes con llave",
    "1819": "Check-in con teclado numérico",
    "1820": "El huésped debe contactarnos para obtener instrucciones",
    "1821": "Lavadora - espacio común",
    "1822": "Secadora - espacio común",
    "1823": "Cuna de viaje",
    "1825": "Futón doble",
    "1826": "Airbnb: Todos pueden hacer reserva instantánea",
    "1827": "Airbnb: Huéspedes con buenas reseñas pueden hacer reserva instantánea",
    "1828": "Airbnb: Huéspedes con identidad verificada pueden hacer reserva instantánea",
    "1829": "Airbnb: Solo huéspedes con buenas reseñas e identidad verificada pueden hacer reserva instantánea",
    "1830": "Escaleras",
    "1831": "Ruido potencial",
    "1832": "Mascotas en la propiedad",
    "1833": "Aparcamiento limitado",
    "1834": "Espacios compartidos",
    "1835": "Servicios limitados",
    "1836": "Armas en la propiedad",
    "1837": "Animales peligrosos",
    "1838": "Acondicionador",
    "1839": "Ducha de lluvia",
    "1840": "Gel de ducha",
    "1841": "Cualquiera de los siguientes: ropero, armarios, vestidor separado",
    "1842": "Equipo de ejercicio",
    "1843": "Tocadiscos",
    "1844": "Bandeja de horno",
    "1845": "Máquina de hacer pan",
    "1846": "Café",
    "1847": "Arrocera",
    "1848": "Triturador de basura",
    "1849": "Lavandería automática cercana",
    "1850": "Acceso al resort",
    "1851": "Amarre para bote",
    "1852": "Hamaca",
    "1853": "Asientos al aire libre",
    "1854": "Cocina al aire libre",
    "1855": "Aparcamiento de pago en las instalaciones",
    "1856": "Estancias largas",
    "1857": "Baño compartido con otros huéspedes",
    "1858": "Baño compartido con el anfitrión",
    "1859": "Baño compartido con familia, amigos, compañeros de piso",
    "1860": "Espacios comunes compartidos con otros huéspedes",
    "1861": "Espacios comunes compartidos con el anfitrión",
    "1862": "Espacios comunes compartidos con familia, amigos, compañeros de piso",
    "1863": "Cámaras de vigilancia en la propiedad",
    "1864": "Equipo de fitness",
    "1865": "Colchón de aire",
    "1866": "Colchón en el suelo",
    "1867": "Barbacoa de gas",
    "1868": "Barbacoa de carbón",
    "1869": "Ubicación frente al océano",
    "1870": "Tarifa de chef",
    "1871": "Chef bajo petición",
    "1873": "Máx. 1 mascota permitida",
    "1874": "Máx. 2 mascotas permitidas",
    "1875": "Máx. 3 mascotas permitidas",
    "1876": "Máx. 4 mascotas permitidas",
    "1877": "Máx. 5 mascotas permitidas",
    "1878": "Tarea de salida: Devolver llaves al hacer el checkout",
    "1879": "Tarea de salida: Apagar luces/electrodomésticos al irse",
    "1880": "Tarea de salida: Encargarse de la basura antes de irse",
    "1881": "Tarea de salida: Cerrar las puertas al irse",
    "1882": "Tarea de salida: Dejar las toallas en un lugar específico",
    "1883": "Tarea de salida: Apagar luces y aire acondicionado",
    "1884": "Tarea de salida: Apagar ventiladores y aparatos electrónicos",
    "1885": "Tarea de salida: Apagar luces y cerrar ventanas",
    "1886": "Tarea de salida: Cerrar ventanas y puertas",
    "1887": "Tarea de salida: Cerrar y devolver la llave",
    "1888": "Tarea de salida: Cerrar puerta y balcón y devolver la llave",
    "1889": "Tarea de salida: Reunir toallas y ropa de cama en la bolsa de ropa",
    "1890": "Tarea de salida: Dejar las toallas en el baño",
    "1891": "Tarea de salida: Reunir toallas y ropa de cama",
    "1892": "Tarea de salida: Limpiar los platos",
    "1893": "Tarea de salida: Sacar la comida de la nevera",
    "1894": "Tarea de salida: Vaciar la basura y poner el lavavajillas",
    "1895": "Tarea de salida: La propiedad sucia conllevará un cargo de limpieza",
    "1897": "Tarea de salida: Desechar la basura en contenedores o vertederos",
    "1898": "Tarea de salida: Instrucciones de reciclaje",
    "1899": "Tarea de salida: Vertederos de basura en pisos específicos",
    "1900": "Tarea de salida: Contenedores/vertederos fuera de la propiedad",
    "1901": "Tarea de salida: Métodos de eliminación en el manual de la casa",
    "1902": "Tarea de salida: Dejar las llaves en la mesa",
    "1904": "Tarea de salida: Dejar las llaves en la caja de seguridad",
    "1905": "Tarea de salida: Dejar las llaves en el llavero de seguridad",
    "1906": "Tarea de salida: Dejar las llaves en la cocina",
    "1907": "Tarea de salida: Dejar las llaves al personal o seguridad",
    "1908": "Solo animales de servicio",
    "1909": "Aparcamiento para bicicletas"
};

window.__pt.ln.propertytype = {
    "1": "Suite",
    "2": "Complejo todo incluido",
    "3": "Apartamento",
    "4": "Alojamiento y desayuno",
    "7": "Chalet",
    "8": "Condominio",
    "16": "Casa de huéspedes",
    "20": "Hotel",
    "22": "Albergue / Lodge",
    "25": "Móvil-home",
    "30": "Complejo turístico",
    "33": "Tienda de campaña",
    "34": "Vivienda vacacional",
    "35": "Villa",
    "37": "Castillo",
    "63": "Apartahotel",
    "64": "Barco",
    "65": "Cabaña / Cottage",
    "66": "Camping",
    "67": "Casa",
    "68": "Habitación privada en apartamento",
    "69": "Habitación compartida",
    "70": "Cabaña de madera",
    "71": "Bungalow",
    "72": "Riad",
    "73": "Vehículo recreacional",
    "74": "Ryokan",
    "75": "Loft / Ático",
    "76": "Casa adosada"
};

window.__pt.ln.propertyselection = {
    "hotel": "Hotel",
    "accommodation": "Casas o departamentos"
};

window.__pt.ln.travelgroup = {
    "959": "Solo adultos",
    "595": "Acepta Mascotas"
};

window.__pt.ln.propertytypes = {
    "1": "Suite completa",
    "2": "Resort todo incluido",
    "3": "Apartamento",
    "4": "Bed and breakfast",
    "7": "Chalet",
    "8": "Condominio",
    "16": "Casa de huéspedes",
    "20": "Hotel",
    "22": "Cabaña",
    "25": "Casa móvil",
    "30": "Resort",
    "33": "Tienda",
    "34": "Casa vacacional",
    "35": "Villa",
    "37": "Castillo",
    "63": "Aparthotel",
    "64": "Barco",
    "65": "Cabaña rural",
    "66": "Camping",
    "67": "Casa",
    "68": "Habitación privada en apartamento",
    "69": "Habitación compartida",
    "70": "Cabaña",
    "71": "Bungaló",
    "72": "Riad",
    "73": "Vehículo recreativo",
    "74": "Ryokan",
    "75": "Loft",
    "76": "Casa adosada"
};